/*eslint-disable*/
'use strict';
import _, { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import React, { memo, forwardRef, useState, useEffect, useMemo } from 'react';
import { nanoid }  from 'nanoid';
import { validate as v, defaultsDeepButNotArray } from '../../../routes/utils/common-util';
import { AMShiftPicker, AMOtWorkHourPicker } from '../eHRMS/am/amInputs';
import { EDJobPicker, EDLevelPicker, EDGradePicker, EDJobCatPicker, EDJobStylePicker, EDIdentityPicker, EDAreaPicker, EDSitePicker, EDFactoryPicker, EDPositionPicker, EDLocationPicker } from '../eHRMS/ed/edInputs';
import { OSSNOPicker, OSLaborNoPicker, OSHNOPicker, OSCompanyPicker, OSOrgTypePicker, OSDeptLevelPicker } from '../eHRMS/os/osInputs';
import { SessionStorage as ss } from './Cache';
import { Loading, TipButton } from './Control';
import { Dialog, StepComponent, StepDialog, Tip, TipBinder } from './Dialogs';
import { HAComponent } from './Generic';
import { SimpleGrid } from './Grids';
import { ReactInput, DepPicker, Picker, OptionPicker, PostcodePicker, PickerWrapper, Text, TextRange, DateRange, NumberRange, TwoSidePicker, DataLoader, Checkbox } from './Input';
import { ColGroup } from './Utils';
import { I18n } from './I18n'

const { getLabel, getOptions } = OptionUtils;
const hcLabel = d => getLabel('ed.job.headCount', d);
const etLabel = d => getLabel('ed.job.empType', d);
const { adapt } = LocaleUtils;
//const NA = <i className={'text-sm color-lightGray'}>N/A</i>;
const NA = ' ';	// 不顯示 N/A，顯示空白

// ruleMaker 默認的 key
const ConditionItems = Object.freeze({
	dep: OptionUtils.getLabel('components.EmpUtils', 'department'),
	deptLeader: OptionUtils.getLabel('components.EmpUtils', 'headOfDepartment'),
	stat: OptionUtils.getLabel('components.EmpUtils', 'incumbentStatus'),
	dates: OptionUtils.getLabel('components.EmpUtils', 'dateRelated'),
	sno: OptionUtils.getLabel('components.EmpUtils', 'withholdingUnit'),
	laborNo: OptionUtils.getLabel('components.EmpUtils', 'laborProtectionCompilation'),
	healthNo: OptionUtils.getLabel('components.EmpUtils', 'healthInsuranceCompilation'),
	position: OptionUtils.getLabel('components.EmpUtils', 'posts'),
	level: OptionUtils.getLabel('components.EmpUtils', 'grade'),
	degree: OptionUtils.getLabel('components.EmpUtils', 'rank'),
	posCate: OptionUtils.getLabel('components.EmpUtils', 'jobCategory'),
	posType: OptionUtils.getLabel('components.EmpUtils', 'occupation'),
	identify: OptionUtils.getLabel('components.EmpUtils', 'identityCategory'),
	empType: OptionUtils.getLabel('components.EmpUtils', 'directAndIndirect'),
	responsibility: OptionUtils.getLabel('components.EmpUtils', 'separationOfResponsibilities'),
	headcount: OptionUtils.getLabel('components.EmpUtils', 'preparationStatus'),
	region: OptionUtils.getLabel('components.EmpUtils', 'workArea'),
	location: OptionUtils.getLabel('components.EmpUtils', 'placeOfWork'),
	factory: OptionUtils.getLabel('components.EmpUtils', 'factoryBy'),
	shiftType: OptionUtils.getLabel('components.EmpUtils', 'classAttributes'),
	shift: OptionUtils.getLabel('hp.m4.m410040', 'banBing'),
	salaryType: OptionUtils.getLabel('components.EmpUtils', 'salaryMethod'),
	trial: OptionUtils.getLabel('components.EmpUtils', 'probationaryExpirationStatus'),
	basic: OptionUtils.getLabel('components.EmpUtils', 'basicData'),
	register: OptionUtils.getLabel('components.EmpUtils', 'householdRegistrationAddressArea'),
	contact: OptionUtils.getLabel('components.EmpUtils', 'mailingAddressArea'),
	partTimeStatus: OptionUtils.getLabel('components.EmpUtils', 'partTimeStatus'),
	emp: OptionUtils.getLabel('components.EmpUtils', 'employee'),
	bid: OptionUtils.getLabel('components.EmpUtils', 'firm'),
});

// 成員條件為跨公司版本時，選單應該只有以下選項
const ConditionItemsForIsCompany = Object.freeze({
	dep: OptionUtils.getLabel('components.EmpUtils', 'department'),
	sno: OptionUtils.getLabel('components.EmpUtils', 'withholdingUnit'),
	laborNo: OptionUtils.getLabel('components.EmpUtils', 'laborProtectionCompilation'),
	healthNo: OptionUtils.getLabel('components.EmpUtils', 'healthInsuranceCompilation'),
	position: OptionUtils.getLabel('components.EmpUtils', 'posts'),
	level: OptionUtils.getLabel('components.EmpUtils', 'grade'),
	degree: OptionUtils.getLabel('components.EmpUtils', 'rank'),
	posCate: OptionUtils.getLabel('components.EmpUtils', 'jobCategory'),
	posType: OptionUtils.getLabel('components.EmpUtils', 'occupation'),
	identify: OptionUtils.getLabel('components.EmpUtils', 'identityCategory'),
	empType: OptionUtils.getLabel('components.EmpUtils', 'directAndIndirect'),
	responsibility: OptionUtils.getLabel('components.EmpUtils', 'separationOfResponsibilities'),
	headcount: OptionUtils.getLabel('components.EmpUtils', 'preparationStatus'),
	region: OptionUtils.getLabel('components.EmpUtils', 'workArea'),
	location: OptionUtils.getLabel('components.EmpUtils', 'placeOfWork'),
	factory: OptionUtils.getLabel('components.EmpUtils', 'factoryBy'),
	shiftType: OptionUtils.getLabel('components.EmpUtils', 'classAttributes'),
	shift: OptionUtils.getLabel('hp.m4.m410040', 'banBing'),
	salaryType: OptionUtils.getLabel('components.EmpUtils', 'salaryMethod'),
	partTimeStatus: OptionUtils.getLabel('components.EmpUtils', 'partTimeStatus'),
	emp: OptionUtils.getLabel('components.EmpUtils', 'employee'),
});


/*** EmpAvatar ***************************************************************************************/
class EmpAvatar extends HAComponent {
	static version = '1.0.0';
	static propTypes = {
		empId: PropTypes.number,
		size: PropTypes.oneOf([30, 40, 50, 60, 80, 100, 120]),
	};
	static defaultProps = {
		size: 40,
	};
	state = {
		error: false,
	};

	static getDerivedStateFromProps(props, state) {
		const { empId } = props;
		const { _empId } = state;
		if (empId != _empId) return { _empId: empId, error: false };
		return null;
	}

	render() {
		const { empId, size, className } = this.props;
		const { error } = this.state;
		return <div className={`avatar avatar-${size} ${className ? className : ''}`}>
			{
				empId && !error ? <img {... {
					src: `api/employee/avatar/${empId}?t=${+new Date()}`,
					onError: evt => this.setState({ error: true }),
				}} /> : null
			}
		</div>;
	}
}

/*** EmpCard *****************************************************************************************/
const _EmpCardAjaxLoader = (_this, force = false) => {
	const { empId, cache, api, onLoadSuccess, onLoadError, funCode, action } = _this.props;
	if (empId === -403) {
		_this.setState({
			loading: false,
			data: OptionUtils.getLabel('components.EmpUtils', 'thisEmployeeViewPermissionIsNot'),
		}, _.isFunction(onLoadError) ? onLoadError() : null);
		return;
	}

	const KEY = `EmpCard:${empId}`;
	if (cache && !force) {
		const data = ss.get(KEY);
		if (data) return _this.setState({ data: data, loading: false });
	}

	// const warn = (prop) => console.error(`%c${_this.constructor.name} 缺少 props.${prop}，請補上正確權限`, 'color:red; font-size:18px');
	// if (!funCode) warn('funCode');
	// if (!action) warn('action');

	const url =
		_.isFunction(api) ? api(empId) :
			_.isString(api) ? `${api.replace(/\/$/, '')}/${empId}${funCode && action ? `/${funCode}/${action}` : ''}` : null;
	if (!url) return;

	if (_this.state.loading && _this._ajax.loader && _this._ajax.loader.empId === empId) return;
	_this._ajax.loader = new _Ajax({
		url,
		method: 'get',
		onRequest: () => _this.setState({ loading: true, data: null }),
		onSuccess: (data, xhr) => {
			_this.setState({
				loading: false,
				data,
			}, () => _.isFunction(onLoadSuccess) ? onLoadSuccess(data) : null);
			if (cache) ss.set(KEY, data);
		},
		isHandleError: false,
		onError: (xhr) => {
			const errCode = {
				490: OptionUtils.getLabel('components.EmpUtils', 'noInformationOnThisEmployeeWas'),
				491: OptionUtils.getLabel('components.EmpUtils', 'thisEmployeeViewPermissionIsNot'),
			};
			_this.setState({
				loading: false,
				data: errCode[xhr.status] || OptionUtils.getLabel('components.EmpUtils', 'readError'),
			}, _.isFunction(onLoadError) ? onLoadError(xhr.status, errCode[xhr.status] || OptionUtils.getLabel('components.EmpUtils', 'readError')) : null);
		},
	}).send();
	_this._ajax.loader.empId = empId;
};

class EmpCard extends HAComponent {
	static version = '1.0.0';
	static propTypes = {
		empId: PropTypes.number,
		type: PropTypes.oneOf(['default', 'simple', 'detail', 'vertical', 'signer', 'portal', /*'account'*/]),
		cache: PropTypes.bool,
		refresh: PropTypes.bool,
		api: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		funCode: PropTypes.string,
		action: PropTypes.string,
		empAvatar: PropTypes.bool,
		tip: PropTypes.bool,
	};
	static defaultProps = {
		empId: 0,
		type: 'default',
		cache: false,
		refresh: true,
		api: '/api/employee/card/',
		empAvatar: true,
		tip: true, // for type='vertical', 61cf41c0 預設 vertical 滑鼠移上去會有 tip
	};
	state = {
		loading: false,
		data: null,
	};

	static getDerivedStateFromProps(props, state) {
		const { empId } = props;
		const { _empId } = state;
		if (empId != _empId) return { _empId: empId, data: null };
		return null;
	}

	componentDidMount() {
		super.componentDidMount();
		_EmpCardAjaxLoader(this);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { data } = this.state;
		if (!data) _EmpCardAjaxLoader(this);
	}

	getEmp() {
		return _.cloneDeep(this.state.data);
	}

	render() {
		const {
			type, cache, refresh, className, style, funCode, action, empAvatar,
			tip,
		} = this.props;
		const { data, loading } = this.state;
		const isError = _.isString(data);
		return <div {...{
			className: `H2-EmpCard ${type}${isError ? ' error' : ''} ${className ? className : ''}`,
			style: style ? style : null,
		}}>{loading
			? <Loading {...{
				...type === 'detail' ? { size: 'md' } : null,
				style: { flexGrow: 1 },
			}} />
			: <>
				{empAvatar ? <EmpAvatar empId={isError || !data ? 0 : data.id} size={_CardAvatarSizes[type] || _CardAvatarSizes.default} className={`-avatar`} /> : null}
				{isError
					? data
					: data
						? <>
							{/*{eval('_render' + type.substring(0, 1).toLocaleUpperCase() + type.substring(1))()}*/}
							{_EmpCardRenderer[type]
								? _EmpCardRenderer[type](data, funCode, action, tip)
								: _EmpCardRenderer.default(data)}
							{cache && refresh && <TipButton {...{
								tip: OptionUtils.getLabel('components.EmpUtils', 'reloadTheData'),
								className: 'btn btn-white btn-xs fa fa-sync -refresh',
								onClick: evt => {
									evt.stopPropagation();
									_EmpCardAjaxLoader(this, true);
								},
							}} />}
						</> : null}
			</>
		}</div>;
	}
}
//for portal的EmpQueryPicker使用
class EmpCardQuery extends HAComponent {
	static version = '1.0.0';
	static propTypes = {
		empId: PropTypes.number,
		type: PropTypes.oneOf(['default']),
		cache: PropTypes.bool,
		refresh: PropTypes.bool,
		api: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		funCode: PropTypes.string,
		action: PropTypes.string,
		empAvatar: PropTypes.bool,
	};
	static defaultProps = {
		empId: 0,
		type: 'default',
		cache: false,
		refresh: true,
		api: '/api/employee/card/',
		empAvatar: true,
	};
	state = {
		loading: false,
		data: null,
		title: '',
		queryEmpDlg: false,
	};

	static getDerivedStateFromProps(props, state) {
		const { empId } = props;
		const { _empId } = state;
		if (empId != _empId) return { _empId: empId, data: null };
		return null;
	}

	componentDidMount() {
		super.componentDidMount();
		_EmpCardAjaxLoader(this);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { data } = this.state;
		if (!data) _EmpCardAjaxLoader(this);
	}

	getEmp() {
		return _.cloneDeep(this.state.data);
	}

	render() {
		const { type, cache, refresh, className, style, funCode, action, empAvatar, getEmpCardQueryPicker, getEmpCardQueryPickerFalse} = this.props;
		const { data, loading, queryEmpDlg, title} = this.state;
		const isError = _.isString(data);
		const getEmpQueryDlg = () =>{ this.setState({ queryEmpDlg: true }), getEmpCardQueryPickerFalse();};
		return <div {...{
			className: `H2-EmpCard ${type}${isError ? ' error' : ''} ${className ? className : ''}`,
			style: {display:'flex'},
		}}>{loading
			? <Loading {...{
				...type === 'detail' ? { size: 'md' } : null,
				style: { flexGrow: 1 },
			}} />
			: <>
					{empAvatar ? <EmpAvatar empId={isError || !data || !data.senFields.includes("EMP_PHOTO_FILE") ? 0 : data.id} size={_CardAvatarSizes[type] || _CardAvatarSizes.default} className={`-avatar`} /> : null}
				{isError
					? data
					: data
						? <>
							{_EmpCardRendererQuery[type]
								? _EmpCardRendererQuery[type](data, funCode, action, queryEmpDlg, getEmpQueryDlg)
								: _EmpCardRendererQuery.default(data,funCode, action, queryEmpDlg, getEmpQueryDlg)}
							{cache && refresh && <TipButton {...{
								tip: OptionUtils.getLabel('components.EmpUtils', 'reloadTheData'),
								className: 'btn btn-white btn-xs fa fa-sync -refresh',
								onClick: evt => {
									evt.stopPropagation();
									_EmpCardAjaxLoader(this, true);
								},
							}} />}
						</> : null}
				{/* 同仁個人資料頁面 */}
				{queryEmpDlg ? <_QueryEmpDlg {...{
					className: '-emp-query-dialog',
					updateTitle: (title)=>{this.setState({title});},
					data,
					title,
					funCode,
					empAvatar,
					close: () => {this.setState({ queryEmpDlg: false }), getEmpCardQueryPicker();},
				}} /> : null}
			</>
			}</div>;
	}
}

/*** EmpPicker ***************************************************************************************/
class EmpPicker extends PickerWrapper {
	static version = '1.0.1';
	static propTypes = {
		bid: PropTypes.number,
		type: PropTypes.oneOf([
			'all',			// 全
			'amRule',		// 出勤規則,
			'notAmRule',	// 沒有出勤規則,
			'suspend',		// 留停,
			'quit',			// 離職,
			'payroll',		// 已建立薪資規則的員工,
			//'leave',		// 有請假的 (for 銷假),
			'worked',		// 曾經在職 (for rollback)
			'portal',		// 有portal帳號的員工
			'shifted', 		// 曾經是排班人員
		]),
		statusTime: PropTypes.oneOf(['before', 'now']),
		between: PropTypes.arrayOf(PropTypes.string), // date-string is better...
		filter: PropTypes.func,
		api: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.func,
			PropTypes.object,
		]),
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		funCode: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
		action: PropTypes.string,
		dataLoaderType: PropTypes.oneOf([
			'ehrms',		// 後台
			'portal',
		]),
		pickerProps: PropTypes.object,
	};
	static defaultProps = {
		type: 'all',
		statusTime: 'before',
		placeholder: OptionUtils.getLabel('components.EmpUtils', 'pickEmployees'),
		validate: { max: 1 },
		dataLoaderType: 'ehrms',
	};
	state = {
		loading: false,
		error: null,
		data: null,
		_bid: null,
		adv: false,
		moreHint: false,
	};

	constructor(props) {
		super(props);
		const { filter: f, type, bid: b, data, funCode, action } = this.props;
		this._bid = (type === 'all' || type === 'portal') ? (b === 0 ? 0 : (b || (user && user.bid))) : (b || (user && user.bid));
		this._filter = (type === 'all' || type === 'portal') ? (f || (emp => emp.ws > 0)) : f;
		this.state.data = data;
		this._wsOptions = [0,1,2,3];
		if(type === 'all' || type === 'portal' || type === 'amRule' || type === 'payroll')
			this._wsOptions = [1,2,3];
		else if(type === 'suspend')
			this._wsOptions = [2];
		else if(type === 'quit')
			this._wsOptions = [3];
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.state.data) return;

		const { api, type, bid, initValue, between, statusTime, onLoadSuccess, onLoadError, funCode, action, onRequest } = this.props;
		let cfg = {
			url: '/api/employee/picker',
			method: 'post',
		};
		if (api) {
			if (_.isString(api)) cfg = { url: api, method: 'get' };
			else if (_.isFunction(api)) cfg = { url: api(), method: 'get' };
			else if (_.isPlainObject(api)) cfg = _.pick(api, ['url', 'method', 'data']);
		}
		if (cfg.method === 'post' && !cfg.data)
			cfg.data = {
				type,
				bid: this._bid,
				statusTime,
				...between ? { between } : null,
			};
		cfg.data = { initValue, ...cfg.data, $funCode: funCode, $action: action };

		new _Ajax({
			...cfg,
			isHandleError: false,
			onRequest: () => {
				this.setState({ loading: true, data: null, error: null },
					() => _.isFunction(onRequest) ? onRequest() : null);
			},
			onSuccess: (data, xhr) => {
				const d = _.isFunction(this._filter) ? _.filter(data, this._filter) : data;
				this.setState({
					loading: false,
					data: d,
					error: null,
				}, () => _.isFunction(onLoadSuccess) ? onLoadSuccess(d) : null);
				//if(!api) ss.set(this._key, data); // 暫時決定不cache
			},
			onError: (xhr) => this.setState({
				loading: false, error: OptionUtils.getLabel('components.EmpUtils', 'failedToReadEmployeeData'),
			}, () => _.isFunction(onLoadError) ? onLoadError() : null),
		}).send();
	}

	getEmps() {
		if (!this._picker || _.isEmpty(this._picker.state.data)) return undefined;
		return _.cloneDeep(_.filter(this._picker.state.data, '_selected'));
	}

	getInitValue() {
		const { initValue } = this.props
		return this._tempValue || initValue
	}

	render() {
		const { type, bid, theme, dataLoaderType, pickerProps, initValue, renderTag } = this.props;
		const { loading, error, data, _bid, adv, moreHint } = this.state;
		if (loading) return <Loading />;
		else if (error) return <span className={'color-red'}>
			<i className={'fa fa-exclamation-circle'} /> {error}
		</span>;

		const isSingle = this.props.validate && this.props.validate.max === 1 && !theme;
		const _initValue = this.getInitValue();
		if (_initValue) delete this._tempValue;
		return data ? <Picker {...{
			..._.omit(this.props, 'type'),
			..._initValue ? { initValue: _initValue } : null,
			ref: ele => this._picker = ele,
			data,
			...isSingle ? { theme: 'select', allowUncheck: true } : null,
			finder: (d, kw) => {
				let { name, no, enName } = d;
				const exp = new RegExp(_.escapeRegExp(kw), 'i');
				return no && exp.test(no) || name && exp.test(name) || enName && exp.test(enName);
			},
			renderTag: (data, idx) => <>
				<span className={`-emp-ws -ws${data.ws}`} /> {_.isEqual(user.locale, 'en_US') ? data.enName || data.name  : data.name || data.enName }
				{data.privilege === -403 ? <>{' '}<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/>
					{OptionUtils.getLabel('components.EmpUtils', 'thisEmployeeViewPermissionIsNot')}
				</small></> : ''}
			</>,
			renderItem: (data, idx) => {
				const { type, bid } = this.props;
				const isGlobal = (type === 'all' || type === 'portal') && bid === 0;
				const com = isGlobal && _.find(OSCompanyPicker.data(), com => com.id === data.comId);

				return <>
					<small className={'color-lightGray'}>{idx + 1}. </small>
					<span className={`-emp-ws -ws${data.ws}`} style={{ margin: '0 3px' }} />
					<span className={'-name text-medium'}>
						{_.isEqual(user.locale, 'en_US') ? data.enName || data.name  : data.name || data.enName } <small className={'extra'}>{data.no}</small>
					</span>
					<small className={'-info text-ellipsis'}>
						{' '}<i className={'fal fa-sm zoom-p80 fa-sitemap'} />{data.depName || NA}
						{' '}<i className={'fal fa-sm zoom-p80 fa-briefcase'} />{data.jobName === -403 ? '******' : data.jobName || NA}
						{data.jobActive === 0 ? <>{' '}<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/>{OptionUtils.getLabel('global.normal', 'disable')}</small></> : ''}
						{com && <div><i className={'fal fa-sm zoom-p80 fa-home-alt'} />{data.privilege === -403 ? '******' : com.name}</div>}
					</small>
				</>;
			},
			menuProps: {
				className: 'emp',
				height: [240, 300],
				finding: true,
				renderCriteria: (criteria, update, selectAllBtn) => {
					const { kw } = criteria;
					const isAll = (type === 'all' || type === 'portal') && bid === 0;
					const _depEvent = v => {
						if (v) {
							criteria.org = v.org;
							criteria.depIds = v.depts;
						} else {
							delete criteria.org;
							delete criteria.depIds;
						}
						update();
					};
					const _jobEvent = v => {
						if (_.isNil(v)) delete criteria.jobIds;
						else criteria.jobIds = _.isArray(v) ? v : [v];
						update();
					};
					const _wsEvent = v => {
						if (_.isNil(v)) delete criteria.ws;
						else criteria.ws = _.isArray(v) ? v : [v];
						update();
					};
					const _enEvent = v => {
						if (_.every(v, _.isEmpty)) delete criteria.empNo;
						else criteria.empNo = v;
						update();
					};
					const menuProps = {
						eventLevel: 1,
						height: [0, 200],
						isCount: false,
						stickOffset: { x: -40, y: 3 },
						stickDirection: 'bottom',
						pointer: 'top',
						pointerClassName: 'sm',
						pointerStyle: { left: 35 },
						width: 500,
						className: 'level2',
					};
					return <>
						<div className={'flex-row'}>
							<i className={'fal fa-fw fa-search fa-sm color-gray'} style={{ margin: '0 0 0 3px' }} />
							<Text {...{
								className: 'empty sm -gum',
								initValue: kw || '',
								placeholder: OptionUtils.getLabel('components.EmpUtils', 'searchForNameEditors'),
								onEditing: v => {
									v = v.trim();
									if (v === kw) return;
									criteria.kw = v;
									update();
								},
							}} />
							{selectAllBtn}
							{!adv && moreHint ? <small className={'color-blue zoom-p90'}>
								{OptionUtils.getLabel('components.EmpUtils', 'moreSearchCriteria')}
								<i className={'fal fa-arrow-right'} />
							</small> : null}
							<span {...{
								className: `btn btn-xs square btn-info fa fa-sliders-h-square ${adv ? ' active' : ''}`,
								style: { margin: '0 2px' },
								onClick: evt => {
									if (adv)
										_.forEach(_.keys(criteria), prop => {
											if (prop !== 'kw') delete criteria[prop];
										});
									this.setState({ adv: !adv }, update);
								},
								...adv ? null : {
									onMouseEnter: evt => this.setState({ moreHint: true }),
									onMouseLeave: evt => this.setState({ moreHint: false }),
								},
							}} />
						</div>

						{adv ? <div className={'flex-row flex-wrap'} style={{ borderTop: '1px dashed #DDD' }}>
							{isAll ? <div className={'-item'}>
								<i className={'fal fa-home fa-xs'} />
								<OSCompanyPicker {...{
									theme: 'select',
									className: 'empty sm',
									validate: { max: 1 },
									allowUncheck: true,
									menuProps,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'companyAffiliation'),
									style: { minWidth: 100 },
									onUpdate: v => this.setState({ _bid: v }, () => {
										criteria.bid = v;
										_.forEach(['jobIds', 'org', 'depIds'], p => delete criteria[p]);
										update();
									}),
									...dataLoaderType === 'portal' ? { api: '/api/h2/options/companies' } : null
								}} />
							</div> : null}
							{(isAll && _bid) || !isAll ? <div className={'-item'}>
								<i className={'fal fa-sitemap fa-xs'} />
								<DepPicker {...{
									...isAll ? { key: _bid + '_dep' } : null,
									..._bid ? { bid: _bid } : null,
									className: 'empty sm',
									orgType: 0,
									behavior: 'simple',
									menuProps,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'department'),
									onEditing: _depEvent,
									onUpdate: _depEvent,
									emptyStyle: { fontSize: 12 },
									dataFilter: d => !d.hasOwnProperty('active') || d.active,
								}} />
							</div> : null}
							{(isAll && _bid) || !isAll ? <div className={'-item'}>
								<i className={'fal fa-briefcase fa-xs'} />
								<EDJobPicker {...{
									...isAll ? { key: _bid + '_job' } : null,
									..._bid ? { bid: _bid } : null,
									className: 'empty sm',
									behavior: 'simple',
									allowUncheck: true,
									menuProps,
									filter: d => true,
									inactiveIsReadOnly: false,
									onEditing: _jobEvent,
									onUpdate: _jobEvent,
									emptyStyle: { fontSize: 12 },
									...dataLoaderType === 'portal' ? { api: `/api/h2/options/${_bid}/jobs` } : null
								}} />
							</div> : null}
							<div className={'-item'}>
								<i className={'fal fa-id-card fa-xs'} />
								<OptionPicker {...{
									data: 'ed.job.workStatus',
									className: 'empty sm',
									behavior: 'simple',
									menuProps,
									filter: this._wsOptions,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'wordStatus'),
									onEditing: _wsEvent,
									onUpdate: _wsEvent,
								}} />
							</div>
							<div className="-item">
								<i className={'fal fa-id-card fa-xs'} />
								<TextRange {...{
									className: 'empty sm alignLeft',
									width: 160,
									placeholder: [
										OptionUtils.getLabel('components.EmpUtils', 'employeeNumberOnwards'), OptionUtils.getLabel('components.EmpUtils', 'employeeNumber')
									],
									onEditing: _enEvent,
									onUpdate: _enEvent,
								}} />
							</div>
						</div> : null}
					</>;
				},
				filterCriteria: (src, criteria, finder) => {
					const { kw, bid, jobIds, org, depIds, ws, empNo = [] } = criteria;
					if (empNo[0]) empNo[0] = empNo[0].toUpperCase();
					if (empNo[1]) empNo[1] = empNo[1].toUpperCase();
					return _.filter(src, d => {
						const _empNo = d.no && d.no.toUpperCase() || '';
						return (kw ? finder(d, kw) : true) &&
							(empNo[0] ? empNo[0] <= _empNo : true) &&
							(empNo[1] ? empNo[1] >= _empNo || _empNo.startsWith(empNo[1]) : true) &&
							(bid ? bid === d.comId : true) &&
							(org && depIds ? _.includes(depIds, d[`depId${org}`]) : true) &&
							(jobIds ? _.includes(jobIds, d.jobId) : true) &&
							(ws ? _.includes(ws, d.ws) : true);
					});
				},
			},
			...pickerProps,
		}} /> : null;
	}
}
/*** EmpQueryPicker for portal同仁資料查詢***************************************************************************************/
class EmpQueryPicker extends PickerWrapper {
	static version = '1.0.1';
	static propTypes = {
		bid: PropTypes.number,
		type: PropTypes.oneOf([
			'all',					// 全
			'amRule',				// 出勤規則,
			'notAmRule',			// 沒有出勤規則,
			'amRuleNotShiftType4',	// 出勤規則且排除「不需排班」的員工
			'suspend',				// 留停,
			'quit',					// 離職,
			'payroll',				// 已建立薪資規則的員工,
			//'leave',				// 有請假的 (for 銷假),
			'worked',				// 曾經在職 (for rollback)
			'portal',				// 有portal帳號的員工
		]),
		between: PropTypes.arrayOf(PropTypes.string), // date-string is better...
		filter: PropTypes.func,
		api: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.func,
			PropTypes.object,
		]),
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		funCode: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
		action: PropTypes.string,
	};
	static defaultProps = {
		type: 'all',
		validate: { max: 1 },
	};
	state = {
		loading: false,
		error: null,
		data: null,
		_bid: null,
		adv: false,
		moreHint: false,
	};

	constructor(props) {
		super(props);
		const { filter: f, type, bid: b, data, funCode, action } = this.props;
		this._bid = (type === 'all' || type === 'portal') ? (b === 0 ? 0 : (b || (user && user.bid))) : (b || (user && user.bid));
		this._filter = (type === 'all' || type === 'portal') ? (f || (emp => emp.ws > 0)) : f;
		this.state.data = data;
		this._wsOptions = [0,1,2,3];
		if(type === 'all' || type === 'portal' || type === 'amRule' || type === 'payroll')
			this._wsOptions = [1,2,3];
		else if(type === 'suspend')
			this._wsOptions = [2];
		else if(type === 'quit')
			this._wsOptions = [3];
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.state.data) return;

		const { api, type, bid, between, statusTime, onLoadSuccess, onLoadError, funCode, action, onRequest } = this.props;
		let cfg = {
			url: '/api/employee/picker/query',
			method: 'post',
		};
		if (api) {
			if (_.isString(api)) cfg = { url: api, method: 'get' };
			else if (_.isFunction(api)) cfg = { url: api(), method: 'get' };
			else if (_.isPlainObject(api)) cfg = _.pick(api, ['url', 'method', 'data']);
		}
		if (cfg.method === 'post' && !cfg.data)
			cfg.data = {
				type,
				statusTime,
				bid: this._bid,
				...between ? { between } : null,
			};
		cfg.data = { ...cfg.data, $funCode: funCode, $action: action };

		this._ajax.empQueryPickerLoad = new _Ajax({
			...cfg,
			isHandleError: false,
			onRequest: () => {
				this.setState({ loading: true, data: null, error: null },
					() => _.isFunction(onRequest) ? onRequest() : null);
			},
			onSuccess: (data, xhr) => {
				const d = _.isFunction(this._filter) ? _.filter(data, this._filter) : data;
				this.setState({
					loading: false,
					data: d,
					error: null,
				}, () => _.isFunction(onLoadSuccess) ? onLoadSuccess(d) : null);
			},
			onError: (xhr) => this.setState({
				loading: false, error: '讀取員工資料失敗',
			}, () => _.isFunction(onLoadError) ? onLoadError() : null),
		}).send();
	}

	getEmps() {
		if (!this._picker || _.isEmpty(this._picker.state.data)) return undefined;
		return _.cloneDeep(_.filter(this._picker.state.data, '_selected'));
	}

	render() {
		const { type, bid, theme, initValue } = this.props;
		const { loading, error, data, _bid, adv, moreHint } = this.state;
		if (loading) return <Loading />;
		else if (error) return <span className={'color-red'}>
			<i className={'fa fa-exclamation-circle'} /> {error}
		</span>;

		const isSingle = this.props.validate && this.props.validate.max === 1 && !theme;
		const _initValue = initValue || this._tempValue;
		if (_initValue) delete this._tempValue;
		return data ? <Picker {...{
			..._.omit(this.props, 'type'),
			..._initValue ? { initValue: _initValue } : null,
			ref: ele => this._picker = ele,
			data,
			...isSingle ? { theme: 'select', allowUncheck: true } : null,
			finder: (d, kw) => {
				let { nameCh, no, enName, officeMail, officeTelExt, personalMail } = d;
				const exp = new RegExp(_.escapeRegExp(kw), 'i');
				return no && exp.test(no) || nameCh && exp.test(nameCh) || enName && exp.test(enName)|| officeMail && exp.test(officeMail) || officeTelExt && exp.test(officeTelExt)|| personalMail && exp.test(personalMail);
			},
			renderTag: (data, idx) => <>
				<span className={`-emp-ws -ws${data.ws}`} /> {data.nameCh ? data.nameCh : data.enName}
				{data.privilege === -403 ? <>{' '}<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/>{OptionUtils.getLabel('components.EmpUtils', 'thisEmployeeViewPermissionIsNot')}</small></> : ''}
			</>,
			renderItem: (data, idx) => {
				const { type, bid } = this.props;
				const isGlobal = (type === 'all' || type === 'portal') && bid === 0;
				const com = isGlobal && _.find(OSCompanyPicker.data(), com => com.id === data.comId);
				return <>
					<small className={'color-lightGray'}>{idx + 1}. </small>
					<span className={`-emp-ws -ws${data.ws}`} style={{ margin: '0 3px' }} />
					<span className={'-name text-medium'}>
						{data.nameCh ? data.nameCh : data.enName} &nbsp;{data.nameCh && data.enName ? data.enName : null}
					</span>
					<small className={'-info text-ellipsis'}>
						{' '}<i className={'fal fa-sm zoom-p80 fa-sitemap'} />{data.depName || NA}
					</small>
				</>;
			},
			menuProps: {
				className: 'emp',
				height: [240, 300],
				renderCriteria: (criteria, update, selectAllBtn) => {
					const { kw } = criteria;
					const isAll = (type === 'all' || type === 'portal') && bid === 0;
					const _depEvent = v => {
						if (v) {
							criteria.org = v.org;
							criteria.depIds = v.depts;
						} else {
							delete criteria.org;
							delete criteria.depIds;
						}
						update();
					};
					const _jobEvent = v => {
						if (_.isNil(v)) delete criteria.jobIds;
						else criteria.jobIds = _.isArray(v) ? v : [v];
						update();
					};
					const _wsEvent = v => {
						if (_.isNil(v)) delete criteria.ws;
						else criteria.ws = _.isArray(v) ? v : [v];
						update();
					};
					const _enEvent = v => {
						if (_.every(v, _.isEmpty)) delete criteria.empNo;
						else criteria.empNo = v;
						update();
					};
					const menuProps = {
						eventLevel: 1,
						height: [0, 200],
						isCount: false,
						stickOffset: { x: -40, y: 3 },
						stickDirection: 'bottom',
						pointer: 'top',
						pointerClassName: 'sm',
						pointerStyle: { left: 35 },
						width: 0,
						className: 'level2',
					};
					return <>
						<div className={'flex-row'}>
							<i className={'fal fa-fw fa-search fa-sm color-gray'} style={{ margin: '0 0 0 3px' }} />
							<Text {...{
								className: 'empty sm -gum',
								initValue: kw || '',
								placeholder: OptionUtils.getLabel('components.EmpUtils', 'searcherNameExtension'),
								onEditing: v => {
									v = v.trim();
									if (v === kw) return;
									criteria.kw = v;
									update();
								},
							}} />
							{selectAllBtn}
						</div>

						{adv ? <div className={'flex-row flex-wrap'} style={{ borderTop: '1px dashed #DDD' }}>
							{isAll ? <div className={'-item'}>
								<i className={'fal fa-home fa-xs'} />
								<OSCompanyPicker {...{
									theme: 'select',
									className: 'empty sm',
									validate: { max: 1 },
									allowUncheck: true,
									menuProps,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'companyAffiliation'),
									style: { minWidth: 100 },
									onUpdate: v => this.setState({ _bid: v }, () => {
										criteria.bid = v;
										_.forEach(['jobIds', 'org', 'depIds'], p => delete criteria[p]);
										update();
									}),
								}} />
							</div> : null}
							{(isAll && _bid) || !isAll ? <div className={'-item'}>
								<i className={'fal fa-sitemap fa-xs'} />
								<DepPicker {...{
									...isAll ? { key: _bid + '_dep' } : null,
									..._bid ? { bid: _bid } : null,
									className: 'empty sm',
									orgType: 0,
									behavior: 'simple',
									menuProps,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'department'),	// 部門
									onEditing: _depEvent,
									onUpdate: _depEvent,
								}} />
							</div> : null}
							{(isAll && _bid) || !isAll ? <div className={'-item'}>
								<i className={'fal fa-briefcase fa-xs'} />
								<EDJobPicker {...{
									...isAll ? { key: _bid + '_job' } : null,
									..._bid ? { bid: _bid } : null,
									className: 'empty sm',
									behavior: 'simple',
									allowUncheck: true,
									menuProps,
									filter: d => true,
									inactiveIsReadOnly: false,
									onEditing: _jobEvent,
									onUpdate: _jobEvent,
								}} />
							</div> : null}
							<div className={'-item'}>
								<i className={'fal fa-id-card fa-xs'} />
								<OptionPicker {...{
									data: 'ed.job.workStatus',
									className: 'empty sm',
									behavior: 'simple',
									menuProps,
									filter: this._wsOptions,
									placeholder: OptionUtils.getLabel('components.EmpUtils', 'wordStatus'),
									onEditing: _wsEvent,
									onUpdate: _wsEvent,
								}} />
							</div>
							<div className="-item">
								<i className={'fal fa-id-card fa-xs'} />
								<TextRange {...{
									className: 'empty sm alignLeft',
									width: 160,
									placeholder: [
										OptionUtils.getLabel('components.EmpUtils', 'employeeNumberOnwards'),
										OptionUtils.getLabel('components.EmpUtils', 'employeeNumber')
									],
									onEditing: _enEvent,
									onUpdate: _enEvent,
								}} />
							</div>
						</div> : null}
					</>;
				},
				filterCriteria: (src, criteria, finder) => {
					const { kw, bid, jobIds, org, depIds, ws, empNo = [] } = criteria;
					if (empNo[0]) empNo[0] = empNo[0].toUpperCase();
					if (empNo[1]) empNo[1] = empNo[1].toUpperCase();
					return _.filter(src, d => {
						const _empNo = d.no && d.no.toUpperCase() || '';
						return (kw ? finder(d, kw) : true) &&
							(empNo[0] ? empNo[0] <= _empNo : true) &&
							(empNo[1] ? empNo[1] >= _empNo || _empNo.startsWith(empNo[1]) : true) &&
							(bid ? bid === d.comId : true) &&
							(org && depIds ? _.includes(depIds, d[`depId${org}`]) : true) &&
							(jobIds ? _.includes(jobIds, d.jobId) : true) &&
							(ws ? _.includes(ws, d.ws) : true);
					});
				},
			},
		}} /> : null;
	}
}

/*** EmpCardPicker ***************************************************************************************/
class EmpCardPicker extends ReactInput {
	static version = '1.0.1';
	static propTypes = {
		cardProps: PropTypes.object,
		onLoadSuccess: PropTypes.func,			// emp card load ready!
		onRawDataLoadSuccess: PropTypes.func,	// emp picker raw data load ready!
		api: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.func,
			PropTypes.object,
		]),
		funCode: PropTypes.string,
		action: PropTypes.string,
	};
	state = {
		...this.state,
		stage: 'input',		// 'input', 'card'
		empId: null,
		hover: false,
	};

	constructor(props) {
		super(props);

		const { value } = this.props;
		if (value) {
			this.state.empId = value;
			this.state.stage = 'card';
		}
	}

	reset() {
		const { enable, editable } = this.state;
		if (!enable || !editable) return this;
		this.setState({ empId: null, stage: 'input' });
		return this;
	}

	validate() {
		const { enable, editable, stage, empId } = this.state;
		if (!enable || !editable) return true;

		return (stage == 'card' && empId) || (stage === 'input' && this._input && this._input.validate());
	}

	enable(cb) {
		return super.enable(() => {
			if (this.state.stage === 'input') this._input.enable();
		});
	}

	disable() {
		return super.enable(() => {
			if (this.state.stage === 'input') this._input.disable();
		});
	}

	editable() {
		return super.editable(() => {
			if (this.state.stage === 'input') this._input.editable();
		});
	}

	readOnly() {
		return super.readOnly(() => {
			if (this.state.stage === 'input') this._input.readOnly();
		});
	}

	getValue() {
		return this.state.empId;
	}

	setValue(value) {
		this.setState({ empId: value, stage: 'card' });
	}

	getEmp() {
		return this._card ? this._card.getEmp() : null;
	}

	render() {
		const { cardProps, onLoadSuccess, onRawDataLoadSuccess, api, funCode, action } = this.props;
		const { stage, empId, editable, enable, hover } = this.state;
		return empId && stage === 'card' ?
			<div {...{
				ref: ele => this._dom.cardWrapper = ele,
				onClick: evt => enable && editable ? this.setState({ stage: 'input' }, () => {
					if (this._input) this._input.focus();
				}) : null,
				onMouseEnter: evt => this.setState({ hover: true }),
				onMouseLeave: evt => this.setState({ hover: false }),
			}}>
				<EmpCard {...{
					ref: ele => this._card = ele,
					funCode, action,
					...cardProps,
					empId, onLoadSuccess,
					className: editable ? 'clickable' : 'readOnly',
					onLoadError: (code, errMsg) => {
						if (code !== 491)
							this.setState({ stage: 'input', empId: null });
					},
				}} />
				{hover ? <Tip {...{
					stick: this._dom.cardWrapper,
					stickDirection: 'auto',
					stickAlign: -1,
					close: () => this.setState({ hover: false }),
				}}>點選可挑選其他員工</Tip> : null}
			</div> :
			<EmpPicker {...{
				ref: ele => this._input = ele,
				...this.props,
				...this._data ? { data: this._data } : null,
				api,
				value: empId,
				validate: {
					required: this.props.validate ? this.props.validate.required : true,
					max: 1,
				},
				allowUncheck: true,
				onUpdate: v => {
					const { onUpdate } = this.props;
					if (!v) return this.setState({ empId: null }, () => _.isFunction(onUpdate) ? onUpdate() : null);
					this.setState({
						empId: +v,
						stage: 'card',
					}, () => _.isFunction(onUpdate) ? onUpdate(v) : null);
				},
				onLoadSuccess: data => {
					this._data = data;
					_.isFunction(onRawDataLoadSuccess) ? onRawDataLoadSuccess(data) : null;
				},
				onBlur: () => this.state.empId ? this.setState({ stage: 'card' }) : null,
			}} />;
	}
}
/*** EmpCardQueryPicker for portal同仁資料查詢***************************************************************************************/
class EmpCardQueryPicker extends ReactInput {
	static version = '1.0.1';
	static propTypes = {
		cardProps: PropTypes.object,
		onLoadSuccess: PropTypes.func,			// emp card load ready!
		onRawDataLoadSuccess: PropTypes.func,	// emp picker raw data load ready!
		api: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.func,
			PropTypes.object,
		]),
		funCode: PropTypes.string,
		action: PropTypes.string,
	};
	state = {
		...this.state,
		stage: 'input',		// 'input', 'card'
		empId: null,
		hover: false,
		queryEmpDlg: '',
	};

	constructor(props) {
		super(props);

		const { value } = this.props;
		if (value) {
			this.state.empId = value;
			this.state.stage = 'card';
		}
	}

	reset() {
		const { enable, editable } = this.state;
		if (!enable || !editable) return this;
		this.setState({ empId: null, stage: 'input' });
		return this;
	}

	validate() {
		const { enable, editable, stage, empId } = this.state;
		if (!enable || !editable) return true;

		return (stage == 'card' && empId) || (stage === 'input' && this._input && this._input.validate());
	}

	enable(cb) {
		return super.enable(() => {
			if (this.state.stage === 'input') this._input.enable();
		});
	}

	disable() {
		return super.enable(() => {
			if (this.state.stage === 'input') this._input.disable();
		});
	}

	editable() {
		return super.editable(() => {
			if (this.state.stage === 'input') this._input.editable();
		});
	}

	readOnly() {
		return super.readOnly(() => {
			if (this.state.stage === 'input') this._input.readOnly();
		});
	}

	getValue() {
		return this.state.empId;
	}

	setValue(value) {
		this.setState({ empId: value, stage: 'card' });
	}

	getEmp() {
		return this._card ? this._card.getEmp() : null;
	}

	render() {
		const { cardProps, onLoadSuccess, onRawDataLoadSuccess, api, funCode, action, width } = this.props;
		const { stage, empId, editable, enable, hover } = this.state;
		const getEmpCardQueryPicker = () => this.setState({ enable: true });
		const getEmpCardQueryPickerFalse = () => this.setState({ enable: false });
		return empId && stage === 'card' ?
			<div {...{
				ref: ele => this._dom.cardWrapper = ele,
				onClick: evt => enable && editable ? this.setState({ stage: 'input'}, () => {
					if (this._input) this._input.focus();
				}) : null,
				onMouseEnter: evt => this.setState({ hover: true}),
				onMouseLeave: evt => this.setState({ hover: false }),
			}}>
				<EmpCardQuery {...{
					ref: ele => this._card = ele,
					funCode, action,
					...cardProps,
					getEmpCardQueryPicker,
					getEmpCardQueryPickerFalse,
					empId, onLoadSuccess,
					className: editable ? 'clickable' : 'readOnly',
					onLoadError: () => this.setState({ stage: 'input', empId: null }),
				}} />
				{hover ? <Tip {...{
					stick: this._dom.cardWrapper,
					stickDirection: 'auto',
					stickAlign: -1,
					close: () => this.setState({ hover: false }),
					style: {
						zIndex: 10
					}
				}}>點選可挑選其他員工</Tip> : null}
			</div> :
			<EmpQueryPicker {...{
				ref: ele => this._input = ele,
				...this.props,
				...this._data ? { data: this._data } : null,
				api,
				value: empId,
				validate: {
					required: this.props.validate ? this.props.validate.required : true,
					max: 1,
				},
				allowUncheck: true,
				onUpdate: v => {
					const { onUpdate } = this.props;
					if (!v) return this.setState({ empId: null }, () => _.isFunction(onUpdate) ? onUpdate() : null);
					this.setState({
						empId: +v,
						stage: 'card',
					}, () => _.isFunction(onUpdate) ? onUpdate(v) : null);
				},
				onLoadSuccess: data => {
					this._data = data;
					_.isFunction(onRawDataLoadSuccess) ? onRawDataLoadSuccess(data) : null;
				},
				onBlur: () => this.state.empId ? this.setState({ stage: 'card' }) : null,
			}} />;
	}
}

/*** EmpRuleMaker ***************************************************************************************/
const STEP_LABELS = [
	OptionUtils.getLabel('components.EmpUtils', 'selectCompany'),
	OptionUtils.getLabel('components.EmpUtils', 'setFilters'),
	OptionUtils.getLabel('components.EmpUtils', 'excludeSpecificPeople'),
	OptionUtils.getLabel('components.EmpUtils', 'previewOfTheResults')];
const BID_RELATIVES = ['sno', 'laborNo', 'healthNo', 'position', 'level', 'degree', 'posCate', 'posType', 'identify', 'region', 'location', 'factory', 'shift'];
const USER_DATA = Object.freeze({
	OSCompanyPicker,
	sno: OSSNOPicker,
	laborNo: OSLaborNoPicker,
	healthNo: OSHNOPicker,
	OSOrgTypePicker,
	OSDeptLevelPicker,
	position: EDJobPicker,
	level: EDGradePicker,
	degree: EDLevelPicker,
	posCate: EDJobCatPicker,
	posType: EDJobStylePicker,
	identify: EDIdentityPicker,
	region: EDAreaPicker,
	location: EDSitePicker,
	factory: EDFactoryPicker,
	shift: AMShiftPicker,
});
const H2_Denied = [''];
class EmpRuleMaker extends ReactInput {
	static version = '1.0.2';
	static propTypes = {
		...ReactInput.propTypes,
		userData: PropTypes.object.isRequired,
		excludeApi: PropTypes.string.isRequired,
		previewApi: PropTypes.string.isRequired,
		isCompany: PropTypes.bool,
		max: PropTypes.number,
		min: PropTypes.number,
		readOnly: PropTypes.bool,
		onFinish: PropTypes.func,
		stepOneKey: PropTypes.array,
		refChief: PropTypes.object,
	};
	static MAX = 100;
	static defaultProps = {
		...ReactInput.defaultProps,
		userData: USER_DATA,
		excludeApi: '/api/company/ruleMaker/exclude',
		previewApi: '/api/company/ruleMaker/preview',
		isCompany: false,
		min: 0,
		max: EmpRuleMaker.MAX,
		readOnly: false,
		// stepOneKey: [
		// 	'dep', 'sno', 'laborNo', 'healthNo', 'position', 'level', 'degree', 'posCate', 'posType',
		// 	'identify', 'empType', 'responsibility', 'headcount', 'region', 'location', 'factory',
		// 	// 'shiftType', 'shift', 'salaryType', 'emp',
		// 	'shift','salaryType', 'emp',
		// ]
		stepOneKey: Object.keys(ConditionItems || {}).filter(k => !H2_Denied.some(d => d == k)),
		alwaysShowBtn: false
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		max: OptionUtils.getLabel('components.EmpUtils', 'youCanOnlyRules'),
		min: OptionUtils.getLabel('components.EmpUtils', 'aMinimumOfRules'),
	};
	state = {
		... this.state,
		companies: null,
		newDlg: false,
		editDlg: null,
		previewDlg: false,
	};
	_companies = null;

	constructor(props) {
		super(props);
		const {min:_min, max:_max, validate} = this.props;
		const min = _min || (validate && validate.min);
		const max = _max || (validate && validate.max);
		this._min = (!min || min > this._max || min < 0) ? 0 : min;
		this._max = (!max || max < 0 || max > EmpRuleMaker.MAX) ? EmpRuleMaker.MAX : max;
	}

	static getDerivedStateFromProps(props, state) {
		const { disable, value } = props;
		const { enable, _value } = state;
		let s = ReactInput.getDerivedStateFromProps(props, state);
		if ((enable || !disable) && !_.isNil(value) && !(value == _value || _.isEqual(value, _value))) {
			if (!s) s = {};
			s._preValue = value;
			s._value = value;
			s.fieldValue = value;
			s.value = _.isObject(value) ? _.cloneDeep(value) : value;
		}
		return s;
	}

	$getValidateRules(){
		const {required, validate} = this.props;
		return {
			required: required || (validate && validate.required),
			min: this._min,
			max: this._max,
		};
	}

	getValue() {
		const v = super.getValue();
		return v ? _.cloneDeep(v) : undefined;
	}

	setValue(value) {
		const { enable, editable } = this.state;
		return enable && editable ? this.setState({ value }) : false;
	}

	reset() {
		if (!super.reset()) return false;
		this.setState({
			value: [],
			settingDlg: false,
			previewDlg: false,
		});
		return this;
	}

	validate() {
		if (super.validate() === true) return true;

		const {required, max, min} = this.$getValidateRules();
		const {value} = this.state;
		const msg = this.props.errorMsg || EmpRuleMaker.ERROR;
		if(required && (!value || value.length < 1)){
			this.setState({error: msg.required});
			return false;
		}
		if(min > 0 && (!value || value.length < min)) {
			this.setState({error: _.template(msg.min)({min})});
			return false;
		}
		if(value && value.length > max) {
			this.setState({error: _.template(msg.max)({max})});
			return false;
		}
		return true;
	}

	render() {
		const {
			userData: USER_DATA , excludeApi, previewApi, isCompany, onFinish, onUpdate, onDelete,
			funCode, action, stepOneKey, refChief, noSubFilt, alwaysShowBtn, empPickerProps, ico
		} = this.props;
		const { value, enable, editable, hover, newDlg, editDlg, viewDlg, previewDlg, error, hoverRuleUid } = this.state;

		const _renderRules = () => {
			const _renderConditions = conditions => {
				const groupedConditions = _.reduce(conditions, (acc, value, key) => {
					if (_.includes(BASIC_COND_ITEMS, key)) acc.basic ? acc.basic.push(key) : acc.basic = [key];
					else if (_.includes(DATE_COND_ITEMS, key)) acc.dates ? acc.dates.push(key) : acc.dates = [key];
					else if (_.includes(DEPT_LEADER_ITEMS, key)) {
						let l = 0;
						let deptLevel = conditions['deptLevel'] || [];
						deptLevel.forEach(deptL=>{ l += deptL.leaderType.length;});
						acc.deptLeader = _.times(l,['']);
					}
					else acc[key] = value;
					return acc;
				}, {});
				return _.map(_.keys(groupedConditions), (key, idx) => key !== 'deniedEmpIds' && <React.Fragment key={key}>
					{idx ? ', ' : ''}
					<strong className="color-blue">
						{ConditionItems[key]}
						<small>({_.isArray(groupedConditions[key]) ? groupedConditions[key].length : '?'})</small>
					</strong>
				</React.Fragment>);
			};
			return <>
				{value && value.length > 0 ? _.map(value, (rule, idx) => <div {...{
					key: rule.uid,
					className: '-rule flex-row',
					onMouseEnter: evt => this.setState({ hoverRuleUid: rule.uid }),
					onMouseLeave: evt => this.setState({ hoverRuleUid: null }),
				}}>
					<span className="-no">{idx + 1}.</span>
					<div className={'-gum -conditions text-ellipsis'}>
						{/* 為了限制浮動的字數給並給予100%寬度 */}
						{isCompany ? <div className={'-company'}>
							<div>&emsp;</div>
							<div className='-content'>
								<i className={'fa fa-home-alt'} style={{
									marginRight: 5
								}}>
									<span style={{marginLeft: 5}}>{OptionUtils.getLabel('components.EmpUtils', 'firmEmp')}</span>
								</i>
								<strong className="color-blue text-ellipsis">
									{USER_DATA.OSCompanyPicker.label(rule.bid)}
								</strong>
							</div>
						</div> : null}
						<div className={'flex-row'}>
							<i className={'fa fa-tasks'}>
								<span style={{marginLeft: 7}}>{OptionUtils.getLabel('components.EmpUtils', 'condition')}</span>
							</i>
							<span className="text-ellipsis -gum">{_renderConditions(rule.conditions)}</span>
						</div>
						{rule.exclude && rule.exclude.length > 0 ? <div className={'flex-row'}>
							<i className={'fa fa-ban'}>
								<span style={{marginLeft: 7}}>{OptionUtils.getLabel('components.EmpUtils', 'exclude')}</span>
							</i>
							<strong className="color-blue">{rule.exclude.length}</strong>
							<span>人</span>
						</div> : null}
					</div>
					{enable && (hoverRuleUid === rule.uid || alwaysShowBtn) ? <div className={'btn-group btn-group-white'}>
						{!editable && <div {...{
							className: 'btn fal fa-eye',
							onClick: evt => this.setState({ viewDlg: rule }),
						}} />}
						{editable && <>
							<div {...{
								className: 'btn fal fa-pen-alt',
								onClick: evt => {
									this.setState({ editDlg: rule });
								},
							}} />
							<div {...{
								className: 'btn red fal fa-times',
								onClick: evt => {
									const preValue = _.cloneDeep(value);
									const deleted = _.remove(value, { uid: rule.uid });
									this.forceUpdate(() => {
										const v = _.cloneDeep(this.state.value);
										_.isFunction(onDelete) ? onDelete(deleted) : null;
										_.isFunction(onUpdate) ? onUpdate(v, preValue) : null;
									});
								},
							}} />
						</>}
					</div> : null}
				</div>) : null}
				<div className={'flex-row'}>
					{enable && editable && ((value && value.length) || 0) < this._max ? <span {...{
						className: '-new -gum',
						onClick: evt => this.setState({ newDlg: true }),
					}}><i className={'fal fa-plus'} />
						<span style={{marginLeft:5}}>{OptionUtils.getLabel('components.EmpUtils', 'establishFilters')}</span>
					</span> : null}
					{enable && value && value.length > 0 ? <span {...{
						className: 'btn btn-white',
						onClick: evt => this.setState({ previewDlg: true }),
					}}><i className={'fa fa-users'} />
						<span style={{marginLeft:5}}>{OptionUtils.getLabel('components.EmpUtils', 'memberCheck')}</span>
					</span> : null}
				</div>
			</>;
		};
		const objAuth = { funCode, action, refChief, noSubFilt };
		return <div {...{
			ref: ele => this._dom.root = ele,
			className: `
				H2-EmpRuleMaker
				${enable && editable ? '' : ' readOnly'}
				${error ? 'error' : ''}
			`,
			... error ? {
				onMouseEnter: evt => {
					if (!enable || !editable) return;
					this.setState({ hover: true });
				},
				onMouseLeave: evt => {
					if (!enable || !editable) return;
					this.setState({ hover: false });
				},
			} : null,
		}}>
			{_renderRules()}
			{enable && editable && newDlg ? <StepDialog {...{
				ico: ico ?  '': 'tasks',
				title: OptionUtils.getLabel('components.EmpUtils', 'establishFilters'),
				initStore: {
					uid: nanoid(),
					bid: isCompany ? null : user.bid,
					conditions: {},
					exclude: [],
					emps: [],
				},
				stepLabels: isCompany ? STEP_LABELS : _.slice(STEP_LABELS, 1),
				stepComponents: isCompany ? [
					<_Step0 key="0" userData={USER_DATA} companies={this._companies} />,
					<_Step1 key="1" {...{
						userData: USER_DATA,
						isCompany,
						...objAuth,
						keys: Object.keys(ConditionItemsForIsCompany),
						empPickerProps,
					}} />,
					<_Step2 key="2" {...{ excludeApi, isCompany, ...objAuth }} />,
					<_Step3 key="3" {...{ previewApi, isCompany, ...objAuth }} />,
				] : [
					<_Step1 key="1" userData={USER_DATA} {...objAuth} keys={stepOneKey} empPickerProps={empPickerProps} />,
					<_Step2 key="2" excludeApi={excludeApi} {...objAuth} />,
					<_Step3 key="3" previewApi={previewApi} {...objAuth} />,
				],
				level: 2,
				close: () => this.setState({ newDlg: false }),
				onFinish: store => {
					delete store._excludeData;
					if (!this.state.value) this.state.value = [];
					const preValue = _.cloneDeep(this.state.value);
					this.state.value.push(store);
					this.state.error = false;
					this.forceUpdate(() => {
						const v = _.cloneDeep(this.state.value);
						_.isFunction(onFinish) ? onFinish(v) : null;
						_.isFunction(onUpdate) && !_.isEqual(preValue, v) ? onUpdate(v, preValue) : null;
					});
				},
			}} /> : null}
			{enable && (editable && editDlg || viewDlg) ? <StepDialog {...{
				ico: ico ?  '': 'tasks', title: viewDlg ? OptionUtils.getLabel('components.EmpUtils', 'reviewTheFilters') : OptionUtils.getLabel('components.EmpUtils', 'editTheFilterCriteria'), refChief,
				initStore: viewDlg || editDlg,
				stepLabels: isCompany ? STEP_LABELS : _.slice(STEP_LABELS, 1),
				stepComponents: isCompany ? [
					<_Step0 key="0" userData={USER_DATA} readOnly={!!viewDlg} />,
					<_Step1 key="1" {...{
						userData: USER_DATA, isCompany,
						readOnly: !!viewDlg,
						...objAuth,
						keys: Object.keys(ConditionItemsForIsCompany),
						showDeactived: false,
						empPickerProps,
					}} />,
					<_Step2 key="2" readOnly={!!viewDlg} {...{ excludeApi, isCompany, ...objAuth }} />,
					<_Step3 key="3" readOnly={!!viewDlg} {...{ previewApi, isCompany, ...objAuth }} />,
				] : [
					<_Step1 key="1" readOnly={!!viewDlg} userData={USER_DATA} {...objAuth} keys={stepOneKey} empPickerProps={empPickerProps} />,
					<_Step2 key="2" readOnly={!!viewDlg} excludeApi={excludeApi} {...objAuth} />,
					<_Step3 key="3" readOnly={!!viewDlg} previewApi={previewApi} {...objAuth} />,
				],
				level: 2,
				close: () => this.setState({ editDlg: false, viewDlg: false }),
				onFinish: store => {
					if (viewDlg) return;
					delete store._excludeData;
					const preValue = _.cloneDeep(this.state.value);
					const idx = _.findIndex(this.state.value, {uid: store.uid});
					if(idx < 0) return;
					delete store.emps;
					this.state.value.splice(idx, 1, store);
					this.forceUpdate(() => {
						const v = _.cloneDeep(this.state.value);
						_.isFunction(onFinish) ? onFinish(v) : null;
						_.isFunction(onUpdate) && !_.isEqual(preValue, v) ? onUpdate(v, preValue) : null;
					});
				},
			}} /> : null}
			{previewDlg ? <_PreviewDlg {...{
				previewApi, isCompany,
				ico: ico ? '' : 'users',
				rules: value,
				...objAuth,
				close: () => this.setState({ previewDlg: false }),
			}} /> : null}
			{error && hover ? <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				pointerStyle: { right: 20, left: 'unset' },
				theme: 'validate',
			}}>{error}</Tip> : null}
		</div>;
	}
}

class _Step0 extends StepComponent {
	static defaultProps = {
		...StepComponent.defaultProps,
		height: 500,
		style: { padding: '10px 20px' },
	};
	state = {
		loading: false,
		companies: null,
		bid: +this.props.store.bid || 0,
	};

	constructor(props) {
		super(props);
		this._preBid = _.cloneDeep(this.props.store.bid);
	}

	componentDidMount() {
		super.componentDidMount();
		const { userData: USER_DATA } = this.props;
		// bid=0是新增的只能顯示使用中資料，但編輯中公司停用需呈現
		const c = this.state.bid == 0 ?_.filter(USER_DATA.OSCompanyPicker.data(), { active: 1 }) : _.filter(USER_DATA.OSCompanyPicker.data(0, false), f => f.active ==1 || f.id == this.state.bid);
		if (c) this.setState({ companies: c });
		else
			USER_DATA.OSCompanyPicker.fetch(USER_DATA.OSCompanyPicker.defaultProps, null, {
				onRequest: () => this.setState({ loading: true, companies: null }),
				onSuccess: data => this.setState({ loading: false, companies: data }),
			});
	}

	isNext() {
		const { companies, bid, fetching } = this.state;
		return !fetching && companies && companies.length > 0 && bid;
	}

	next(cb) {
		const { userData: USER_DATA } = this.props;
		const { bid } = this.state;
		this.props.store.bid = bid;
		if (this._preBid != bid) {
			this.props.store.conditions = {};
			this.props.store.exclude = [];
			this.props.store.emps = [];
			this.props.store._excludeData = null;
		}

		// check cache
		const needFetches = _.reduce(BID_RELATIVES, (acc, itemKey) => {
			const PickerClass = USER_DATA[itemKey];
			if (PickerClass?.data(bid) === null) acc.push(PickerClass);
			return acc;
		}, []);
		if (_.isEmpty(needFetches)) cb();
		else {
			this.setState({ fetching: true }, () => {
				let counter = needFetches.length;
				_.each(needFetches, PickerClass => {
					PickerClass.fetch(PickerClass.defaultProps, bid, {
						onSuccess: () => {
							if (--counter === 0) {
								this.setState({ fetching: false }, cb);
							}
						},
					});
				});
			});
		}
	}

	renderBody() {
		const { readOnly } = this.props;
		const { loading, fetching, companies, bid } = this.state;
		return loading ? <Loading size={'lg'} /> :
			companies ? (
				companies.length > 0 ? _.map(companies, (com, idx) => <div {...{
						key: com.id,
						className: `H2-CheckableBlock lg${bid === com.id ? ' active' : ''}${readOnly || fetching ? ' readOnly' : ''}`,
						...(readOnly || fetching) && { style: { cursor: 'not-allowed' } },
						...!readOnly && !fetching && { onClick: evt => this.setState({ bid: com.id }) },
					}}>
						<i className={'-no'}>{idx + 1}.</i>
						<span className={'-content'}>
						<span className="text-medium">{com.name}</span> ({com.code})
					</span>
					</div>) :
					<div className={'notice notice-md ico'}>
						<i className={'fa fa-exclamation-triangle'} />
						{OptionUtils.getLabel('components.EmpUtils', 'thereAreCurrentlyNoOtherCompanies')}
					</div>
			) : null;
	}
}

const BASIC_COND_ITEMS = ['sex', 'age', 'exp', 'serial', 'card', 'nationality'];
const DATE_COND_ITEMS = ['arrive', 'leave', 'stop'];
const DEPT_LEADER_ITEMS = ['orgType', 'deptLevel'];

class _Step1 extends StepComponent {
	static defaultProps = {
		...StepComponent.defaultProps,
		height: 500,
	};
	state = {
		active: null,
		userData: null,
		loading: false,
	};

	constructor(props) {
		super(props);
		const { readOnly, userData: USER_DATA, store: { conditions, bid } } = this.props;
		this._preCondiditions = _.cloneDeep(conditions);

		if (_.keys(conditions).length > 0) {
			const keys = _.keys(conditions);
			const key = keys[0];
			this.state.active =
				_.includes(BASIC_COND_ITEMS, key) ? 'basic' :
					_.includes(DATE_COND_ITEMS, key) ? 'dates' :
						_.includes(DEPT_LEADER_ITEMS, key) ? 'deptLeader' : key;
			if (USER_DATA[key]) {
				this.state.userData = this.getUserData(key);
			}
			this.state.checkingEmpIds = !readOnly && _.includes(keys, 'emp');
		} else this.state.active = _.keys(ConditionItems)[0];
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.state.checkingEmpIds) {
			const { funCode, action, refChief: { bid, empId } = 0, store: { conditions } } = this.props;
			this._ajax = new _Ajax({
				url: '/api/company/ruleMaker/chkEmpIds',
				data: {
					$funCode: funCode, $action: action, bid, empId,
					ids: conditions.emp,
				},
				onSuccess: empIds => {
					if (!_.isEmpty(empIds)) {
						const { store: { conditions } } = this.props;
						_.pull(conditions.emp, ...empIds);
						conditions.deniedEmpIds = empIds;
					}
					this.setState({ checkingEmpIds: false });
				},
				onError: () => {
					this.setState({ checkingEmpIds: false });
				},
			}).send();
		}
	}

	getUserData(key) {
		const { userData: USER_DATA, showDeactived, store: { conditions, bid } } = this.props;
		const SelectIds = conditions[key]?.map(x => x.toString()) || [];
		return USER_DATA[key].data(bid, showDeactived).filter(item => {
			const isActive = item.active === 1;
			const isSelect = SelectIds.indexOf(item.id.toString()) !== -1;
			return isActive || isSelect;
		})
	}

	isNext() {
		const { isCompany, store } = this.props;
		const { conditions } = store;
		const c = _.compact(_.values(conditions));
		return isCompany || c.length > 0;
	}

	next(cb) {
		const { isCompany, store } = this.props;
		const { conditions } = store;
		if (!_.isEmpty(conditions.deniedEmpIds)) {
			conditions.emp = [...conditions.emp || [], ...conditions.deniedEmpIds];
			delete conditions.deniedEmpIds;
		}
		const c = _.compact(_.values(conditions));
		if (isCompany || c.length > 0) {
			if (!_.isEqual(this._preCondiditions, conditions)) {
				this.props.store._excludeData = null;
				this.props.store.exclude = [];
				this.props.store.emps = [];
			}
			if (!this.props.store.exclude) this.props.store.exclude = [];
			cb();
		}
	}

	renderBody() {
		const {
			userData: USER_DATA, isCompany, readOnly, keys, store: { bid, conditions },
			funCode, action, refChief, empPickerProps
		} = this.props;
		const { active, userData, loading, checkingEmpIds, orgTypeCode } = this.state;
		const items = [...(keys || Object.keys(ConditionItems).filter(k => !H2_Denied.some(d => d == k)))];
		_.pull(items, 'bid'); // 移除最後面的 '公司'
		if (isCompany) items.unshift('bid'); // 在最前面加上 '公司'

		const _amount = (key) => {
			if (key === 'bid')
				return 1; // dummy
			if (key === 'dates')
				return _.reduce(DATE_COND_ITEMS, (count, k) => count += conditions[k] ? 1 : 0, 0);
			if (key === 'basic')
				return _.reduce(BASIC_COND_ITEMS, (count, k) => count += conditions[k] ? 1 : 0, 0);
			if (key === 'deptLeader'){
				let l = 0;
				let deptLevel = conditions['deptLevel'] || [];
				deptLevel.forEach(deptL=>{ l += deptL.leaderType.length;});
				return l;
			}
			if (key === 'emp')
				return _.size(conditions.deniedEmpIds) + (_.isNil(conditions.emp) ? 0 : _.isArray(conditions.emp) ? conditions.emp.length : 1);

			const d = conditions[key];

			return _.isArray(d) ? d.length : 0;
		};
		let restItemData;
		let isCheckedAll;
		const checkedItemIds = conditions[active];
		if (_.includes(BID_RELATIVES, active)) {
			restItemData = _.xor(_.map(userData, 'id').map(x => x.toString()), _.map(checkedItemIds, String));
			isCheckedAll = _.isEmpty(restItemData);
		} else {
			const itemData = getOptions({
				stat: 'ed.job.workStatus',
				empType: 'ed.job.empType',
				responsibility: 'ed.job.responsibility',
				headcount: 'ed.job.headCount',
				shiftType: 'am.base.shiftType',
				salaryType: 'pb.base.salary_type',
				trial: 'ed.job.isPassProbation',
				partTimeStatus: 'am.emp.partTimeStatus.label',
			}[active]);
			if (active === 'stat') delete itemData['0'];
			if (!_.isEmpty(itemData)) {
				const keys = _.keys(itemData);
				restItemData = _.xor(keys, checkedItemIds);
				isCheckedAll = _.isEmpty(restItemData);
			}
		}
		const _renderUserData = (key, data) => {
			return loading ? <Loading size={'lg'} /> : _.map(data, (d, idx) => {
				const isChecked = conditions[key] && Array.isArray(conditions[key]) ? conditions[key].some(c => c == d.id) : false;
				return <div {...{
					key: d.id,
					className: `H2-CheckableBlock${isChecked ? ' active' : ''}${readOnly ? ' readOnly' : ''}`,
					...readOnly && { style: { cursor: 'not-allowed' } },
					...!readOnly && {
						onClick: evt => {
							if (isChecked) {
								_.remove(conditions[key], memberId => memberId == d.id);
								if (conditions[key].length === 0) delete conditions[key];
							} else if (conditions[key]) conditions[key].push(d.id);
							else conditions[key] = [d.id];
							this.forceUpdate();
						},
					}
				}}>
					<i className={'-no'}>{idx + 1}.</i>
					<span className={'-content'}>
						<span className="text-medium">{d.name} </span>
						<small>{d.no || d.code ? `(${d.no || d.code})` : null}</small>
					</span>
					{
						d.active === 0 && (
							<small className="msg sm red">
								<i className="fa fa-sm fa-exclamation-circle"></i>
								{OptionUtils.getLabel('global.normal', 'disable')}
							</small>
						)
					}
				</div>;
			})
		};
		const _renderConstantData = (key, dataKey) => {
			const data = getOptions(dataKey);
			if (key === 'stat') delete data[0];
			return _renderUserData(key, _.reduce(_.keys(data), (result, id) => {
				result.push({ id, name: data[id] });
				return result;
			}, []));
		};

		const _pickerProps = {
			minHeight: 60, maxHeight: 120,
			initValue: conditions[active],
			validate: { max: 0 },
			readOnly,
			onUpdate: v => {
				// _.isArray(v) ? v : [v]; 因為戶籍地區選擇一個的時候是數字 無法計算長度 所以單個選項預設 array
				if (!v || v.length === 0) delete conditions[active];
				else conditions[active] = _.isArray(v) ? v : [v];
				this.forceUpdate();
			},
		};
		const objRef = refChief && { bid: refChief.bid, empId: refChief.empId };
		return <div className={'H2-VerticalSet'} style={{ height: 500 }}>
			<div className={'-left'} style={{ width: 180 }}>
				<div className="-tabs block">
					{items.map(key => {
						const isActive = active === key;
						const count = _amount(key);
						return <div key={key} {...{
							className: `-tab${isActive ? ' active' : ''}`,
							...key === active ? null : {
								onClick: evt => setTimeout(() => {
									if (_.includes(_.keys(USER_DATA), key)) {
										const raw = this.getUserData(key);
										if (raw) this.setState({ active: key, userData: raw });
										else USER_DATA[key].fetch(USER_DATA[key].defaultProps, bid, {
											onRequest: () => this.setState({ active: key, loading: true }),
											onSuccess: data => this.setState({ active: key, loading: false, userData: data }),
										});
									} else this.setState({ active: key });
								}, 0),
							},
						}}>
							{isActive ? <i className={'fal fa-arrow-right'} /> : null}
							{' '}
							{isCompany && key === 'bid'
								? <><span className="fa fa-lock" /> {'公司'}</>
								: ConditionItems[key]}
							<span className={'-count zoom-p90'}>{count ? count : ''}</span>
						</div>;
					})}
				</div>
			</div>
			<div className={'-center borderLayout'} style={{ borderLeft: '1px solid #DDD' }}>
				<div className={'-top'} style={{ padding: '5px 20px' }}>
					<h3>
						{ConditionItems[active]}
						<small style={{ marginLeft: 5 }}>(<span className="color-blue">{_amount(active)}</span>)</small>
						{!_.isNil(restItemData) && !readOnly && <div style={{ flexGrow: 1, textAlign: 'right' }}>
							<div className={'btn-group toggle'}>
								<div {...{
									className: `btn btn-white${isCheckedAll ? ' active' : ''}`,
									onClick: () => {
										if (isCheckedAll) delete conditions[active];
										else if (_.isNil(conditions[active])) conditions[active]= restItemData;
										else conditions[active].push(...restItemData);
										this.forceUpdate();
									},
								}}>{getLabel('global.normal', 'selectAll')}</div>
							</div>
						</div>}
					</h3>
				</div>
				<div className={'-center'} style={{ padding: '5px 20px', top: 54 }}>
					{(() => {
						switch (active) {
							// case 'bid':
							// 	return USER_DATA.OSCompanyPicker.label(bid);
							case 'dep':
								return readOnly
									? <_Step1DepGrid {...{
										api: '/api/company/ruleMaker/list/dep',
										method: 'post',
										query: { ids: conditions[active] },
									}} />
									: <DepPicker {...{
										...isCompany ? { bid } : null,
										readOnly,
										minHeight: 60, maxHeight: 120, orgType: -1,
										initValue: conditions[active],
										inactiveIsReadOnly: false,
										dataFilter: d => !d.hasOwnProperty('active') || d.active || (conditions[active] && Array.isArray(conditions[active]) && conditions[active].includes(d.id+'')),
										onUpdate: v => {
											if (!v || v.length === 0) delete conditions[active];
											else conditions[active] = _.reduce(v, (result, ele) => _.concat(result, ele.depts), []);
											this.forceUpdate();
										},
									}} />;
							case 'emp':
								return readOnly
									? <_Step1EmpGrid {...{
										api: '/api/company/ruleMaker/list/emp',
										method: 'post',
										query: { ids: _pickerProps.initValue, funCode, action, ...objRef },
									}} />
									: checkingEmpIds
										? <Loading size={'3x'} />
										: <>
											{!_.isEmpty(conditions.deniedEmpIds) && <div className="H2-Picker readOnly" style={{ marginTop: 10 }}>
												<div className="-tags " style={{ minHeight: 60 }}>
													{_.map(conditions.deniedEmpIds, empId => <div key={empId} className="tag ">******</div>)}
												</div>
												<i className="-lock color-gray fa fa-lock-alt" />
											</div>}
											<EmpPicker {...{
												funCode, action,
												..._pickerProps,
												...isCompany ? { bid } : null,
												...objRef && { api: { url: '/api/company/emps', method: 'get' } },
												...empPickerProps,
											}} />
										</>;
							case 'register':
								return <PostcodePicker {..._pickerProps} {...readOnly && { maxHeight: undefined }} />;
							case 'contact':
								return <PostcodePicker {...{
									..._pickerProps,
									...readOnly && { maxHeight: undefined },
									key: 'contact',
								}} />;
							case 'sno':
							case 'laborNo':
							case 'healthNo':
							case 'position':
							case 'level':
							case 'degree':
							case 'posCate':
							case 'posType':
							case 'identify':
							case 'region':
							case 'location':
							case 'factory':
							case 'shift':
								return _renderUserData(active, userData.filter(v => v.isSectionShift !== 1));
							case 'stat':
								return _renderConstantData(active, 'ed.job.workStatus');
							case 'empType':
								return _renderConstantData(active, 'ed.job.empType');
							case 'responsibility':
								return _renderConstantData(active, 'ed.job.responsibility');
							case 'headcount':
								return _renderConstantData(active, 'ed.job.headCount');
							case 'shiftType':
								return _renderConstantData(active, 'am.base.shiftType');
							case 'salaryType':
								return _renderConstantData(active, 'pb.base.salary_type');
							case 'trial':
								return _renderConstantData(active, 'ed.job.isPassProbation');
							case 'partTimeStatus':
								return _renderConstantData(active, 'am.emp.partTimeStatus.label');
							case 'dates':
								return <div className={'form-horizontal'}>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'dateOfArrival')}
										</div>
										<div className={'col-xs-14'}><DateRange {...{
											readOnly,
											initValue: conditions.arrive,
											valueType: 'string',
											infinity: 'both',
											onUpdate: v => {
												//(v[0]==null && v[1]==null) 元件點下移出 為填入值會有 [null,null]
												if (!v || v.length === 0|| (v[0]==null && v[1]==null)) delete conditions.arrive;
												else conditions.arrive = v;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'dateOfDeparture')}
										</div>
										<div className={'col-xs-14'}><DateRange {...{
											readOnly,
											initValue: conditions.leave,
											valueType: 'string',
											infinity: 'both',
											onUpdate: v => {
												//(v[0]==null && v[1]==null) 元件點下移出 為填入值會有 [null,null]
												if (!v || v.length === 0|| (v[0]==null && v[1]==null)) delete conditions.leave;
												else conditions.leave = v;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'leaveWithoutPayDate')}
										</div>
										<div className={'col-xs-14'}><DateRange {...{
											readOnly,
											initValue: conditions.stop,
											valueType: 'string',
											infinity: 'both',
											onUpdate: v => {
												//(v[0]==null && v[1]==null) 元件點下移出 為填入值會有 [null,null]
												if (!v || v.length === 0 || (v[0]==null && v[1]==null)) delete conditions.stop;
												else conditions.stop = v;
												this.forceUpdate();
											},
										}} /></div>
									</div>
								</div>;
							case 'basic':
								return <div className={'form-horizontal'}>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'gender')}
										</div>
										<div className={'col-xs-14'}>{_renderConstantData('sex', 'ed.base.gender')}</div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'ageRange')}
										</div>
										<div className={'col-xs-14'}><NumberRange {...{
											readOnly,
											initValue: conditions.age,
											infinity: 'both',
											placeholder: readOnly ? ['', ''] : [15, 99],
											validate: {
												required: false,
												min: 15,
												max: 99,
											},
											onUpdate: v => {
												if (!v || _.compact(v).length === 0) delete conditions.age;
												else conditions.age = v;
												this.forceUpdate();
											},
											onError: () => {
												delete conditions.age;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'seniorityRange')}
										</div>
										<div className={'col-xs-14'}><NumberRange {...{
											readOnly,
											initValue: conditions.exp,
											infinity: 'both',
											float: true,
											precision: 1,
											placeholder: readOnly ? ['', ''] : [0, 100],
											validate: {
												required: false,
												min: 0,
												max: 100,
											},
											onUpdate: (v, pre, comp) => {
												if (!v || (v[0] === undefined && v[1] === undefined)) delete conditions.exp;
												else {
													// 若輸入非 0.5 倍數，自動往上加為 0.5 倍數（例：3.2 → 3.5）
													const snapToHalf = n => (n === undefined || n === null) ? n : Math.ceil(n * 2) / 2;
													const snapped = [snapToHalf(v[0]), snapToHalf(v[1])];
													conditions.exp = snapped;
													// 同步更新畫面上的數字
													if (comp) {
														comp.state.value = [...snapped];
														const { field0, field1 } = comp._dom;
														if (field0 && snapped[0] !== v[0]) field0.setValue(snapped[0]);
														if (field1 && snapped[1] !== v[1]) field1.setValue(snapped[1]);
													}
												}
												this.forceUpdate();
											},
											onError: () => {
												delete conditions.exp;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'staffingRange')}
										</div>
										<div className={'col-xs-14'}><TextRange {...{
											readOnly,
											initValue: conditions.serial,
											infinity: 'both',
											placeholder: readOnly ? ['', ''] : ['A0001', 'A9999'],
											onUpdate: v => {
												if (!v || _.compact(v).length === 0) delete conditions.serial;
												else conditions.serial = v;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'employeeCardNumberRange')}
										</div>
										<div className={'col-xs-14'}><TextRange {...{
											readOnly,
											initValue: conditions.card,
											infinity: 'both',
											placeholder: readOnly ? ['', ''] : ['00000', '99999'],
											onUpdate: v => {
												v = _.compact(v);
												if (!v || _.compact(v).length === 0) delete conditions.card;
												else conditions.card = v;
												this.forceUpdate();
											},
										}} /></div>
									</div>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'nationality')}
										</div>
										<div className={'col-xs-14'}><OptionPicker {...{
											readOnly,
											data: 'ed.base.country',
											// validate: { required: false },
											placeholder: OptionUtils.getLabel('components.EmpUtils', 'nationality'),
											initValue: conditions.nationality,
											onUpdate: v => {
												if (v) conditions.nationality = _.isArray(v) ? v : [v];
												else delete conditions.nationality;
												this.forceUpdate();
											},
										}} />
										</div>
									</div>
								</div>;
							case 'deptLeader':
								return <div className={'form-horizontal'}>
									<div className={'form-group'}>
										<div className={'control-label col-xs-6'}>
											{OptionUtils.getLabel('components.EmpUtils', 'organizationChart')}
										</div>
										<div className={'col-xs-14'}>
											<USER_DATA.OSOrgTypePicker {...{
												readOnly,
												component: 'Select',
												initValue: _.get(USER_DATA.OSOrgTypePicker.data()?.find(o => o.code == conditions.orgType), 'id'),
												allowUncheck: true,
												onUpdate: v => {
													delete conditions.deptLevel;
													delete conditions.orgType;
													if (!v || v.length === 0) {
														this.setState({ orgTypeCode: undefined });
													} else {
														this.setState({ orgTypeCode: USER_DATA.OSOrgTypePicker.data()?.find(o => o.id === v).code });
													}
													this.forceUpdate();
												},
											}} />
										</div>
									</div>
									{
										USER_DATA.OSDeptLevelPicker.data()?.filter(o => o.orgTypeCode == (orgTypeCode || conditions.orgType)).map((level, index) => <div {...{
											key: level.id,
											style: { display: 'flex', alignItems: 'center' },
											className: 'col-xs-offset-6 col-xs-14',
										}}>
											{level.name} {' '} {OptionUtils.getLabel('components.EmpUtils', 'level')}
											<Checkbox {...{
												readOnly,
												data: getOptions('os.leader.type'),
												initValue: _.get((conditions.deptLevel || []).find(o => o.levelId === level.id), 'leaderType'),
												style: { margin: '0 3' },
												onUpdate: (v) => {
													_.remove(conditions.deptLevel, deptLevel => deptLevel.levelId === level.id);
													if (_.isArray(v) && v.length !== 0) {
														if (!_.isArray(conditions.deptLevel)) conditions.deptLevel = [];
														conditions.deptLevel.push({
															levelId: level.id,
															leaderType: v,
														});
													}
													if (conditions.deptLevel.length === 0) {
														this.setState({ orgTypeCode: conditions.orgType });
														delete conditions.deptLevel;
														delete conditions.orgType;
													} else {
														conditions.orgType = orgTypeCode || conditions.orgType;
													}
													this.forceUpdate();
												},
											}} />
										</div>)
									}
								</div>;
							default:
								return null;
						}
					})()}
				</div>
			</div>
		</div>;
	}
}

class _Step2 extends StepComponent {
	static defaultProps = {
		...StepComponent.defaultProps,
		height: 500,
	};
	state = {
		loading: false,
		emps: null,
	};

	componentDidMount() {
		super.componentDidMount();

		const {
			excludeApi, isCompany, store: { bid, conditions, _excludeData }, funCode, action, refChief, noSubFilt,
		} = this.props;
		const { emp } = conditions;
		if (emp && !Array.isArray(emp)) conditions.emp = [emp];		//EmpPicker僅選1筆時非陣列，需轉換
		if (_excludeData)
			return this.setState({ loading: false, emps: _excludeData });

		this._ajax.load = new H2.Ajax({
			url: excludeApi,
			method: 'post',
			data: { bid, conditions, funCode, action, target: isCompany ? 'ac' : 'ed', bChief: !!refChief, noSubFilt },
			onRequest: () => this.setState({ loading: true }),
			onSuccess: (data, xhr) => {
				this.setState({ loading: false, emps: data });
				this.props.store._excludeData = data;
			},
			onError: (xhr) => this.setState({ loading: false, emps: [] }),
		}).send();
	}

	renderBody() {
		const { readOnly } = this.props;
		const { exclude } = this.props.store;
		const { loading, emps } = this.state;
		const { adapt } = LocaleUtils;

		const _renderEmps = (emps) => {
			const { isCompany, store: { exclude } } = this.props;
			const getExcludedIdIndex = (exclude, empId) => {
				if (exclude && Array.isArray(exclude)) return exclude.findIndex(e => e == empId);
				return -1;
			};

			return _.map(emps, (emp, idx) => {
				const excludedIdIndex = getExcludedIdIndex(exclude, emp.id);
				const isDenied = emp.id === -403;

				return <div {...{
					key: isDenied ? String.uniqueID() : emp.id,
					className: `H2-CheckableBlock red${excludedIdIndex > -1 ? ' active' : ''}${isDenied ? ' disable' : ''}`,
					...readOnly && { style: { cursor: 'not-allowed' } },
					...!isDenied && !readOnly && {
						onClick: evt => {
							if (excludedIdIndex > -1) exclude.splice(excludedIdIndex, 1);
							else exclude.push(emp.id);
							this.forceUpdate();
						},
					},
				}}>
					<i className={'-no'}>{idx + 1}.</i>
					<span className={'-content'}>
						<span className="text-medium">{isDenied ? OptionUtils.getLabel('components.EmpUtils', 'noPermissions') : emp.name} </span>
						{!isDenied && <small className={'opacity-75'}>
							{isCompany ? adapt(emp.companyName) : ''}{' '}
							{adapt(emp.depName)}{' '}
							{emp.jobName === -403 ? '******' : adapt(emp.jobName)}
						</small>}
					</span>
				</div>;
			});
		};
		return loading ? <Loading size={'lg'} /> :
			emps ? <div className={'borderLayout'}>
				<div className={'-top'} style={{ padding: '5px 20px' }}>
					<h3>
						{OptionUtils.getLabel('components.EmpUtils', 'numberOfExcluded')}
						<span className={'color-red'} style={{ marginLeft: 8 }}>{exclude ? exclude.length : 0}</span>
					</h3>
				</div>
				<div className={'-center'} style={{ padding: '5px 20px', top: 40 }}>
					{emps.length === 0 ? <div className={'notice notice-md ico'}>
						<i className={'fa fa-info-circle'} />
						{OptionUtils.getLabel('components.EmpUtils', 'ifThereAreNoEligibleEmployees')}
					</div> : _renderEmps(emps)}
				</div>
			</div> : null;
	}
}

class _Step3 extends StepComponent {
	static defaultProps = {
		...StepComponent.defaultProps,
		height: 500,
		style: { padding: '10px 20px' },
	};
	state = {
		loading: false,
		data: null,
	};
	isFinish() { return !this.state.loading; }
	componentDidMount() {
		super.componentDidMount();

		const {
			previewApi, isCompany, funCode, action, store: { bid, conditions, exclude }, refChief, noSubFilt,
		} = this.props;
		this._ajax.load = new H2.Ajax({
			url: previewApi,
			method: 'post',
			data: {
				rules: [{ bid, conditions, exclude }],
				target: isCompany ? 'ac' : 'ed',
				funCode, action, bChief: !!refChief,
				noSubFilt,
			},
			onRequest: () => {
				this.setState({ loading: true });
			},
			onSuccess: (data, xhr) => {
				this.props.store.emps = [...data];
				this.setState({ loading: false, data });
			},
			onError: (xhr) => this.setState({ loading: false, data: null }),
		}).send();
	}

	renderBody() {
		const { isCompany } = this.props;
		const { loading, data } = this.state;

		const _renderGrid = data => <_PreviewEmpGrid {...{
			data, isCompany,
			colWidths: isCompany ? [40, '*', 135, 220, '20', '20'] : [40, 135, 220, '25', '25'],
		}} />;
		return loading ? <Loading size={'lg'} /> :
			data && data.length > 0 ? _renderGrid(data) : <div className={'notice notice-md ico'}>
				<i className={'fa fa-info-circle'} />
				{OptionUtils.getLabel('components.EmpUtils', 'accordingToTheFilterCriteria')}
			</div>;
	}
}

class _Step1DepGrid extends SimpleGrid {
	renderGridHeader() {
		const { TH } = this;
		return <tr>
			<TH.seq />
			<TH.sortable sortKey={'typeName'}>
				{OptionUtils.getLabel('components.EmpUtils', 'organizationChartCategories')}
			</TH.sortable>
			<TH.sortable sortKey={'name'}>
				{OptionUtils.getLabel('components.EmpUtils', 'departmentName')}
			</TH.sortable>
		</tr>;
	}

	renderGridBody(data, idx, allData) {
		const { TD } = this;
		return <>
			<TD.seq idx={idx} />
			<TD.denied>{data.typeName}</TD.denied>
			<TD.denied>{data.name}</TD.denied>
		</>;
	}
}
class _Step1EmpGrid extends SimpleGrid {
	renderGridHeader() {
		const { TH } = this;
		return <tr>
			<TH.seq />
			<TH.sortable sortKey={'no'}>{OptionUtils.getLabel('global.normal', 'staff')}</TH.sortable>
			<TH.sortable sortKey={'name'}>{OptionUtils.getLabel('global.normal', 'name')}</TH.sortable>
		</tr>;
	}

	renderGridBody(data, idx, allData) {
		const { TD } = this;
		return <>
			<TD.seq idx={idx} />
			<TD.denied>{data.no}</TD.denied>
			<TD.denied>{data.name}</TD.denied>
		</>;
	}
}
class _PreviewEmpGrid extends SimpleGrid {
	renderGridHeader() {
		const { TH } = this;
		const { isCompany ,data, funCode} = this.props;
		return <>
		{funCode =='M110040' ?
		<div style={{width:740, fontWeight:'bold', textAlign:'right'}}>
			<I18n key1='components.EmpUtils' key2='numberOfSelectedPeople' options={{'temp1': data.length}} />
		</div> :null}
		<tr>
			<TH.seq />
			<TH.sortable sortKey={'empNo'}>{OptionUtils.getLabel('global.normal', 'staff')}</TH.sortable>
			<TH.sortable sortKey={'name'}>{OptionUtils.getLabel('global.normal', 'name')}</TH.sortable>
			{isCompany ? <TH.i18nSortable sortKey={'companyName'}>
				{OptionUtils.getLabel('components.EmpUtils', 'firm')}
			</TH.i18nSortable> : null}
			<TH.i18nSortable sortKey={'depName'}>
				{OptionUtils.getLabel('components.EmpUtils', 'department')}
			</TH.i18nSortable>
			<TH.sortable sortKey={'jobIdSort'}>
				{OptionUtils.getLabel('components.EmpUtils', 'posts')}
			</TH.sortable>
		</tr></>;
	}

	renderGridBody(data, idx, allData) {
		const { TD } = this;
		const { isCompany } = this.props;
		const isDenied = data.empId === -403;
		return <>
			<TD.seq idx={idx} />
			<TD.denied>{data.empNo}</TD.denied>
			<TD.denied>{data.name}</TD.denied>
			{isCompany ? <TD.adapt {...{isDenied}}>{data.companyName}</TD.adapt> : null}
			<TD.adapt {...{isDenied}}>{data.depName}</TD.adapt>
			<TD.adapt isDenied={data.jobId === -403}>{data.jobName}</TD.adapt>
		</>;
	}
}

class _PreviewDlg extends Dialog {
	static defaultProps = {
		...Dialog.defaultProps,
		title: OptionUtils.getLabel('components.EmpUtils', 'reviewMembers'),
		isOk: false,
		cancelText: OptionUtils.getLabel('global.normal', 'close'),
		height: '70%',
		level: 3,
	};
	state = {
		loading: false,
		data: null,
	};

	componentDidMount() {
		super.componentDidMount();
		const { previewApi, isCompany, rules, funCode, action, refChief, noSubFilt } = this.props;

		this._ajax.load = new H2.Ajax({
			url: previewApi,
			method: 'post',
			data: {
				rules,
				target: isCompany ? 'ac' : 'ed',
				funCode, action, bChief: !!refChief,
				noSubFilt,
			},
			onRequest: () => this.setState({ loading: true }, () => this.position()),
			onSuccess: (data, xhr) => this.setState({ loading: false, data }, this.position),
			onError: (xhr) => this.setState({ loading: false, data: null }),
		}).send();
	}

	renderBody() {
		const { isCompany, funCode} = this.props;
		const { loading, data } = this.state;

		const _renderGrid = data => <_PreviewEmpGrid {...{
			data, isCompany, funCode,
			colWidths: isCompany ? [40, '*', '15', '20', '20', '20'] : [40, '*', '20', '25', '25'],
		}} />;
		return loading ? <Loading size={'lg'} /> :
			data && data.length > 0 ? _renderGrid(data) : <div className={'notice notice-md ico'}>
				<i className={'fa fa-info-circle'} />
				{OptionUtils.getLabel('components.EmpUtils', 'accordingToTheFilterCriteria')}
			</div>;
	}
}
class _QueryEmpDlg extends Dialog {
	static defaultProps = {
		...Dialog.defaultProps,
		title: ``,
		ico: 'user',
		isOk: false,
		cancelText: OptionUtils.getLabel('global.normal', 'close'),
		width: 700,
		level: 5,
	};
	state = {
		...this.state,
		loading: false,
		hover: false,
	};

	componentDidMount() {
		const { data, funCode, empAvatar } = this.props;
		this._ajax.load = new H2.Ajax({
			url: '/api/employee/queryEmpCardPortal',
			method: 'post',
			data: { data: { ...data, funCode, empAvatar } },
			onRequest: () => this.setState({ loading: true }),
			onSuccess: data => {
				this.setState({ loading: false, data });
				// setParent's state
				this.props.updateTitle(`
				${data[0].EMP_NAME ? data[0].EMP_NAME : ""} ${data[0].EMP_EN_NAME ? data[0].EMP_EN_NAME : ""} ${data[0].EMP_ALIAS_NAME ? "(" + data[0].EMP_ALIAS_NAME + ")" : ""}
				`);
			},
		}).send();
	}

	renderBody() {
		const { loading, data } = this.state;
		const _renderGrid = data => <_QueryEmpDlgGrid {...{
			data,
		}} />;
		return loading ? <Loading size={'lg'} /> :
			data && data.length > 0 ? _renderGrid(data) : <div className={'notice notice-md ico'}>
				<i className={'fa fa-info-circle'} />
				{OptionUtils.getLabel('components.EmpUtils', 'thereAreCurrentlyNoEligibleEmployees')}
			</div>;
	}
}

class _QueryEmpDlgGrid extends SimpleGrid {
	render(){
		const {
			BIRTHDAY, MARITAL_STATUS, DEPT1_ID, DEPT1_NAME, JOB_NAME, HIRE_DATE, OFFICE_TEL, OFFICE_TEL_EXT, HOME_TEL, LIVE_TEL, MOBILE_TEL, OFFICE_EMAIL, PERSONAL_EMAIL, LIVE_ADDRESS, CONTACT_ADDRESS_TW, CONTACT_ADDRESS_EN, SCHOOL_NAME, COMPANY_NAME, SOCIAL_ACCOUNT1, SOCIAL_ACCOUNT2, URGENCY_CONTACT1, URGENCY_CONTACT2, URGENCY_RELATION1, URGENCY_RELATION2, URGENCY_TEL1, URGENCY_TEL2, URGENCY_MOBILE1, URGENCY_MOBILE2, LIVE_POSTAL_CODE, CONTACT_POSTAL_CODE, LEVEL_NAME,GRADE_NAME
		}=this.state.data[0];
		const data = this.state.data[0];
		return<>
			<table className="table table-view">
				<ColGroup cols={[180, '*']} />
				<tbody>
					<tr >
						{data.hasOwnProperty("DEPT1_ID") ? <th >
							{OptionUtils.getLabel('components.EmpUtils', 'sector')}
						</th> : null}
						{data.hasOwnProperty("DEPT1_ID") ? DEPT1_ID ? <td >{DEPT1_ID}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("DEPT1_NAME") ? <th >
							{OptionUtils.getLabel('global.normal', 'departmentName')}
						</th> : null}
						{data.hasOwnProperty("DEPT1_NAME") ? DEPT1_NAME ? <td >{DEPT1_NAME}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("JOB_NAME") ? <th>
							{OptionUtils.getLabel('components.EmpUtils', 'positionTitle')}
						</th> : null}
						{data.hasOwnProperty("JOB_NAME") ? JOB_NAME ? <td>{JOB_NAME}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("LEVEL_NAME") ? <th>
							{OptionUtils.getLabel('components.EmpUtils', 'gradeGrade')}
						</th> : null}
						{data.hasOwnProperty("LEVEL_NAME") ? GRADE_NAME && LEVEL_NAME ? <td>{GRADE_NAME}/{LEVEL_NAME}</td> : !GRADE_NAME && LEVEL_NAME ? <td>--/{LEVEL_NAME}</td> : GRADE_NAME && !LEVEL_NAME ? <td>{GRADE_NAME}/--</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("HIRE_DATE") ? <th>
							{OptionUtils.getLabel('components.EmpUtils', 'dateOfArrival')}
						</th> : null}
						{data.hasOwnProperty("HIRE_DATE") ? HIRE_DATE ? <td>{HIRE_DATE}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("BIRTHDAY") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'dateOfBirth')}</th> : null}
						{data.hasOwnProperty("BIRTHDAY") ? BIRTHDAY ? <td>{BIRTHDAY}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("MARITAL_STATUS") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'maritalStatus')}</th> : null}
						{data.hasOwnProperty("MARITAL_STATUS") ? MARITAL_STATUS ? <td>{getLabel('ed.base.marriageStatus', MARITAL_STATUS)}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("SCHOOL_NAME") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'highestEducation')}</th> : null}
						{data.hasOwnProperty("SCHOOL_NAME") ? SCHOOL_NAME ? <td>{getLabel('ed.edu.education', SCHOOL_NAME)}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("COMPANY_NAME") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'recentExperience')}</th> : null}
						{data.hasOwnProperty("COMPANY_NAME") ? COMPANY_NAME ? <td>{COMPANY_NAME}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("OFFICE_TEL") || data.hasOwnProperty("OFFICE_TEL_EXT") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'companyPhone')}</th> : null}
						{data.hasOwnProperty("OFFICE_TEL") || data.hasOwnProperty("OFFICE_TEL_EXT") ? OFFICE_TEL && OFFICE_TEL_EXT ? <td>{OFFICE_TEL}#{OFFICE_TEL_EXT}</td> : OFFICE_TEL && !OFFICE_TEL_EXT ? <td>{OFFICE_TEL}</td> : !OFFICE_TEL && OFFICE_TEL_EXT ? <td>#{OFFICE_TEL_EXT}</td> :<td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("OFFICE_EMAIL") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'companyEMail')}</th> : null}
						{data.hasOwnProperty("OFFICE_EMAIL") ? OFFICE_EMAIL ? <td>{OFFICE_EMAIL}</td>  : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("PERSONAL_EMAIL") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'personalEMail')}</th> : null}
						{data.hasOwnProperty("PERSONAL_EMAIL") ? PERSONAL_EMAIL ? <td>{PERSONAL_EMAIL}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("MOBILE_TEL") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'mobilePhone')}</th> : null}
						{data.hasOwnProperty("MOBILE_TEL") ? MOBILE_TEL ? <td>{MOBILE_TEL}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("LIVE_TEL") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'familyRegistrationTelephone')}</th> : null}
						{data.hasOwnProperty("LIVE_TEL") ? LIVE_TEL ? <td>{LIVE_TEL}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("LIVE_ADDRESS") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'registeredAddress')}</th> : null}
						{data.hasOwnProperty("LIVE_ADDRESS") ? LIVE_POSTAL_CODE ? <td>{getLabel('ed.base.postalCode', LIVE_POSTAL_CODE)} {LIVE_ADDRESS}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("HOME_TEL") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'homePhone')}</th> : null}
						{data.hasOwnProperty("HOME_TEL") ? HOME_TEL ? <td>{HOME_TEL}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("CONTACT_ADDRESS_TW") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'mailingAddress')}</th> : null}
						{data.hasOwnProperty("CONTACT_ADDRESS_TW") ? CONTACT_POSTAL_CODE ? <td>{getLabel('ed.base.postalCode', CONTACT_POSTAL_CODE)}{CONTACT_ADDRESS_TW}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("CONTACT_ADDRESS_EN") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'foreignAddress')}</th> : null}
						{data.hasOwnProperty("CONTACT_ADDRESS_EN") ? CONTACT_ADDRESS_EN ? <td>{CONTACT_ADDRESS_EN}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("SOCIAL_ACCOUNT1") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'socialAccount')}</th> : null}
						{data.hasOwnProperty("SOCIAL_ACCOUNT1") ? SOCIAL_ACCOUNT1 ? <td>{SOCIAL_ACCOUNT1}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("SOCIAL_ACCOUNT2") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'socialAccount2')}</th> : null}
						{data.hasOwnProperty("SOCIAL_ACCOUNT2") ? SOCIAL_ACCOUNT2 ? <td>{SOCIAL_ACCOUNT2}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("URGENCY_CONTACT1") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'emergencyContact')}</th> : null}
						{data.hasOwnProperty("URGENCY_CONTACT1") ? URGENCY_CONTACT1 ? <td>{URGENCY_CONTACT1}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("URGENCY_RELATION1") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'emergencyContactRelationship1')}</th> : null}
						{data.hasOwnProperty("URGENCY_RELATION1") ? URGENCY_RELATION1 ? <td>{getLabel('ed.family.relation', URGENCY_RELATION1)}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("URGENCY_TEL1") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'phone')}</th> : null}
						{data.hasOwnProperty("URGENCY_TEL1") ? URGENCY_TEL1 ? <td>{URGENCY_TEL1}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("URGENCY_MOBILE1") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'mobilePhone1')}</th> : null}
						{data.hasOwnProperty("URGENCY_MOBILE1") ? URGENCY_MOBILE1 ? <td>{URGENCY_MOBILE1}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("URGENCY_CONTACT2") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'emergencyContacts2')}</th> : null}
						{data.hasOwnProperty("URGENCY_CONTACT2") ? URGENCY_CONTACT2 ? <td>{URGENCY_CONTACT2}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("URGENCY_RELATION2") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'emergencyContactRelationships2')}</th> : null}
						{data.hasOwnProperty("URGENCY_RELATION2") ? URGENCY_RELATION2 ? <td>{getLabel('ed.family.relation', URGENCY_RELATION2)}</td> : <td>--</td> : null}
					</tr>
					<tr >
						{data.hasOwnProperty("URGENCY_TEL2") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'phone2')}</th> : null}
						{data.hasOwnProperty("URGENCY_TEL2") ? URGENCY_TEL2 ? <td>{URGENCY_TEL2}</td> : <td>--</td> : null}
					</tr>
					<tr>
						{data.hasOwnProperty("URGENCY_MOBILE2") ? <th>{OptionUtils.getLabel('components.EmpUtils', 'mobilePhone2')}</th> : null}
						{data.hasOwnProperty("URGENCY_MOBILE2") ? URGENCY_MOBILE2 ? <td>{URGENCY_MOBILE2}</td> : <td>--</td> : null}
					</tr>
				</tbody>
			</table>
		</>;

	}
}

const NonEmpAvatar = React.memo(props => {
	const { size, className } = props;
	let _size = Number(size);
	if (!_size || !_.includes([40, 50, 60, 80, 100, 120], _size))
		_size = 40;

	return <div className={`avatar avatar-${_size} -nonEmp ${className ? className : ''}`} />;
});

const NonEmpCard = React.memo(props => {
	const { id, type, className, onLoadSuccess, onLoadError } = props;
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [data, setData] = useState(null);

	useEffect(() => {
		const ajax = new H2.Ajax({
			url: `/api/non-employee/card/${id}`,
			method: 'get',
			onRequest: () => {
				setLoading(true);
				setError(false);
				setData(null);
			},
			onSuccess: data => {
				setData(data);
				setLoading(false);
				if (_.isFunction(onLoadSuccess)) onLoadSuccess(data);
			},
			isHandleError: false,
			onError: xhr => {
				setError(true);
				setLoading(false);
				if (_.isFunction(onLoadError)) onLoadError();
			},
		}).send();
		return () => ajax.isRunning() && ajax.cancel();
	}, [id]);

	return <div {...{
		className: `H2-EmpCard ${type}${error ? 'error' : ''} ${className ? className : ''}`,
	}}>{loading
		? <Loading {...{
			...type === 'default' ? { size: 'md' } : null,
			style: { flexGrow: 1 },
		}} />
		: error || !data
			? OptionUtils.getLabel('components.EmpUtils', 'noInformationOnThisNonEmployee')
			: _NonEmpCardRenderer[type]
				? _NonEmpCardRenderer[type](data)
				: _NonEmpCardRenderer.default(data)
	}</div>;
});

// 'default', 'simple', 'detail', 'account', 'portal', 'vertical'
const _CardAvatarSizes = { default: 80, detail: 100, simple: 40, vertical: 100, signer: 40 };
const _EmpCardRenderer = {
	default: data => {
		const { id: empId, name, empNo, compName, depName, jobName, workStatus, headcountStatus } = data;
		return <>
			{/*<EmpAvatar empId={empId} size={80} className={`-avatar`} />*/}
			<div className={'-empBody'}>
				<div className="-row major">
					<span className="text-medium">{name}</span>
					<small className={'text-normal'}>{empNo}</small>
					<span className={`-emp-ws -ws${workStatus} -txt`} />
				</div>
				<div className="-row">
					{/*<i className="fal fa-briefcase" />*/}
					<i className="fal fa-home-alt" />
					{adapt(compName) || NA} <i className={'-split'} /> {hcLabel(headcountStatus) || NA}
				</div>
				<div className="-row">
					<i className="fal fa-sitemap" />
					{adapt(depName) || NA} <i className={'-split'} /> {jobName === -403 ? '******' : adapt(jobName) || NA}
				</div>
			</div>
		</>;
	},
	detail: data => {
		const { id: empId, name, empNo, compName, depName, jobName, workStatus, headcountStatus, identityName, employeeType } = data;
		return <>
			{/*<EmpAvatar empId={empId} size={100} className={`-avatar`} />*/}
			<div className={'-empBody'}>
				<div className="-row major">
					<span className="text-medium">{name}</span>
					<small className={'text-normal'}>{empNo}</small>
					<span className={`-emp-ws -ws${workStatus} -txt`} />
				</div>
				<div className="-row">
					{/*<i className="fal fa-briefcase" />*/}
					<i className="fal fa-home-alt" />
					{adapt(compName) || NA} <i className={'-split'} /> {hcLabel(headcountStatus) || NA}
				</div>
				<div className="-row">
					<i className="fal fa-sitemap" />
					{adapt(depName) || NA} <i className={'-split'} /> {jobName === -403 ? '******' : adapt(jobName) || NA}
				</div>
				<div className="-row">
					<i className="fal fa-user" />
					{adapt(identityName) || NA} <i className={'-split'} /> {etLabel(employeeType) || NA}
				</div>
			</div>
		</>;
	},
	simple: data => {
		const { id: empId, name, empNo, depName, jobName, workStatus, identityName, employeeType } = data;
		return <>
			{/*<EmpAvatar empId={empId} size={40} className={`-avatar`} />*/}
			<div className={'-empBody'}>
				<div className="-row major">
					<span className="text-medium">{name}</span>
					<small className={'text-normal'}>{empNo}</small>
					<span className={`-emp-ws -ws${workStatus} -txt`} />
				</div>
				<div className="-row">
					{adapt(depName) || NA} <i className={'-split'} /> {jobName === -403 ? '******' : adapt(jobName) || NA}<i className={'-split'} />
					{adapt(identityName) || NA} <i className={'-split'} /> {etLabel(employeeType) || NA}
				</div>
			</div>
		</>;
	},
	vertical: (data, funCode, action, tip) => {
		// 垂直模式的部門，使用簡稱
		const { id: empId, name, empNo, depAbbrName, jobName, workStatus, identityName } = data;
		const body = <div className={'-empBody'}>
			<div className="-row major">
				<span className={`-emp-ws -ws${workStatus}`} />
				<span className="text-medium">{name}</span>
			</div>
			<div className="-row major">
				<small className={'text-normal'}>{empNo}</small>
			</div>
			<div className="-row">
				<i className="fal fa-sitemap" />
				{adapt(depAbbrName) || NA}
			</div>
			<div className="-row">
				<i className="fal fa-briefcase" />
				{jobName === -403 ? '******' : adapt(jobName) || NA}
			</div>
			<div className="-row">
				<i className="fal fa-user" />
				{adapt(identityName) || NA}
			</div>
		</div>;
		if (!tip) return body;
		return <>
			{/*<EmpAvatar empId={empId} size={100} className={`-avatar`} />*/}
			<TipBinder {...{
				tip: <EmpCard {...{ empId, funCode, action, type: 'detail', empAvatar: false }} />,
				direction: 'right',
				tipProps: { tipMargin: 3 },
			}}>
				{body}
			</TipBinder>
		</>;
	},
	signer: data => {
		const { name, empNo } = data;
		return <>
			<div className={'-empBody'}>
				<div className="-row major">
					<span className="text-medium">{name}</span>
					<small className={'text-normal'}>{empNo}</small>
				</div>
			</div>
		</>;
	},
	portal: data => {
		const { gender, name, empNo, compName, depName, depCode, jobName, hireDate, officeTelExt, officeEmail, isError } = data;
		return <>
			 <div className={'-empBody'}>
				<div className="-row major">
					<span className="text-medium">{name}</span><i {...{ className: `fa fa-fw fa-${gender !== 1 ? 'venus' : 'mars'} color-${gender !== 1 ? 'pink' : 'blue'}` }} />
					<i className="-split" />
					<small><i className={'fal fa-home-alt'} /> {adapt(compName)}</small>
				</div>
				<div className="-row">
					{OptionUtils.getLabel('components.EmpUtils', 'staffEditor')} {empNo}
					<i className="-split" />
					<i className="fal fa-sitemap" />{depName ? adapt(depName) : NA}
					{depCode ? ({depCode}) : NA}
					<i className="-split" />
					<i className="fal fa-briefcase" />{jobName ? adapt(jobName) : NA}
				</div>
				<div className="-row">
					{OptionUtils.getLabel('components.EmpUtils', 'arrivalDate')} {hireDate}
					<i className="-split" />
					<i className="fal fa-phone" />{officeTelExt ? officeTelExt : NA}
					<i className="-split" />
					<i className="fal fa-envelope" />{officeEmail ? officeEmail : NA}
				</div>
			</div>
		</>;
	},
};

//for portal的EmpQueryPicker使用
const _EmpCardRendererQuery = {
	default: (data,funCode, action, queryEmpDlg, getEmpQueryDlg) => {
		const { id: empId, nameCh, empNo, enName, officeEmail, officeTel, officeTelExt, personalEmail} = data;
		return <>
			<div className={'-empBody'} >
				{nameCh && nameCh.length >= 10 || (nameCh && nameCh.length + enName && enName.length >= 15) ?
					<div className="-row major" style={{ maxWidth: 180, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', float:'left'}}>
						{!data.senFields.includes("EMP_NAME") && !data.senFields.includes("EMP_EN_NAME") ? "--" :
							nameCh && data.senFields.includes("EMP_NAME") ?
								<span className="text-medium">{nameCh}</span>
								:
								nameCh && !data.senFields.includes("EMP_NAME") && enName && data.senFields.includes("EMP_EN_NAME") ?
									<span className="text-medium">{enName}</span> :
									"--"
						}
						{nameCh && data.senFields.includes("EMP_NAME") && enName && data.senFields.includes("EMP_EN_NAME") ?
							<small style={{ paddingLeft: 5 }}>{enName}</small>
							: null}
					</div>
					:
					<div className="-row major" >
						{!data.senFields.includes("EMP_NAME") && !data.senFields.includes("EMP_EN_NAME") ? "--" :
							nameCh && data.senFields.includes("EMP_NAME") ?
								<span className="text-medium">{nameCh}</span>
								:
								nameCh && !data.senFields.includes("EMP_NAME") && enName && data.senFields.includes("EMP_EN_NAME") ?
									<span className="text-medium">{enName}</span> :
									"--"
						}
						{nameCh && data.senFields.includes("EMP_NAME") && enName && data.senFields.includes("EMP_EN_NAME") ?
							<small style={{ paddingLeft: 5 }}>{enName}</small>
							: null}
					</div>}
				{(officeTel && officeTel.length >= 17) || (officeTelExt && officeTelExt.length >= 17) || (officeTel && officeTel.length + officeTelExt && officeTelExt.length >= 19)?
					<div className="-row" style={{ maxWidth: 180, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', float: 'left' }}>
						<i className="fal fa-phone" />
						{!data.senFields.includes("OFFICE_TEL") ? "--" :
							officeTel && officeTelExt ? <span>{officeTel}#{officeTelExt}</span>
								: officeTel && !officeTelExt ? officeTel
									: !officeTel && officeTelExt ? <span>#{officeTelExt}</span>
										: '--'
						}
					</div>
					:
					<div className="-row" style={{clear:'both'}}>
						<i className="fal fa-phone" />
						{!data.senFields.includes("OFFICE_TEL") ? "--" :
							officeTel && officeTelExt ? <span>{officeTel}#{officeTelExt}</span>
								: officeTel && !officeTelExt ? officeTel
									: !officeTel && officeTelExt ? <span>#{officeTelExt}</span>
										: "--"
						}
					</div>
				}
				<div className="-row" style={{ maxWidth: 180, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', float: 'left' }}>
					<i className="fal fa-mailbox" />
					{!data.senFields.includes("OFFICE_EMAIL") ? "--" :
						officeEmail && data.senFields.includes("OFFICE_EMAIL") ? <a href={`mailto:${officeEmail}`}
							target="_blank" rel="noreferrer"> {officeEmail} </a>
							: personalEmail && data.senFields.includes("PERSONAL_EMAIL") ? <a href={`mailto:${personalEmail}`}
								target="_blank" rel="noreferrer"> {personalEmail} </a>
								: "--"
					}
				</div>
				{/* 點擊查看更多區塊，會先停止點選可挑選其他員工
				 */}
				{user.empId !== 0 ?
					<div style={{ float: 'right' }} onClick={evt => { evt.stopPropagation(), getEmpQueryDlg(); }}>查看更多</div>
					: null}
			</div>
		</>;
	},
};
const _NonEmpCardRenderer = {
	default: data => {
		const { nonEmpType, nonEmpNo, nonEmpName, nationality, idcNo } = data;
		return <>
			<NonEmpAvatar size={80} className={nonEmpType === 0 ? '-user' : '-company'} />
			<div className={'-empBody'}>
				<div className="-row major">
					{nonEmpType === 0 && <i className="fa fa-fw fa-user-secret color-blue" />}
					{nonEmpType === 1 && <i className="fa fa-fw fa-building color-blue" />}
					<span className="text-medium">{nonEmpName}</span>
					<small className={'text-normal'}>{nonEmpNo}</small>
				</div>
				<div className="-row">
					{idcNo} <i className={'-split'} /> {getLabel('ed.base.country', nationality)}
				</div>
			</div>
		</>;
	},
};

class NonEmpPicker extends PickerWrapper {
	static defaultProps = {
		...PickerWrapper.defaultProps,
		type: 'all',
		placeholder: OptionUtils.getLabel('components.EmpUtils', 'pickNonEmployees'),
		validate: { max: 1 },
		api: {
			url: '/api/non-employee/picker',
			method: 'post',
		},
		loadErrMsg: OptionUtils.getLabel('components.EmpUtils', 'failedToReadNonEmployeeData'),
		menuProps: {
			className: 'emp',
			height: [240, 300],
			placeholder: OptionUtils.getLabel('components.EmpUtils', 'search'),
		},
		isAdvCriteria: false,
	};

	state = {
		...this.state,
		loading: false,
		error: null,
		data: null,
		_bid: null,
		adv: false,
		moreHint: false,
	};

	constructor(props) {
		super(props);

		this.finder = this.finder.bind(this);
		this.renderTag = this.renderTag.bind(this);
		this.renderItem = this.renderItem.bind(this);

		this.$init();
	}

	$init() {
		const { type, bid, data, filter } = this.props;

		this._bid = (bid === 0 && type === 'all') ? 0 : (bid || user && user.bid);
		this._filter = filter;
		this.state.data = data;
		if (!_.isNil(data)) this.state.loading = false;
	}

	componentDidMount() {
		super.componentDidMount();

		if (!this.state.data) this._load();
	}

	_load() {
		if (this.state.loading) return;

		const { type, api, between, onLoadSuccess, onLoadError, loadErrMsg } = this.props;
		let cfg;
		if (_.isString(api)) cfg = { url: api, method: 'get' };
		else if (_.isFunction(api)) cfg = { url: api(), method: 'get' };
		else {
			cfg = _.defaults({}, api, {
				data: {
					type,
					bid: this._bid,
					...between ? { between } : null,
				},
			});
		}

		this._ajax = new _Ajax({
			...cfg,
			isHandleError: false,
			onRequest: () => this.setState({ loading: true, data: null, error: null }),
			onSuccess: (data, xhr) => {
				const d = _.isFunction(this._filter) ? _.filter(data, this._filter) : data;
				this.setState({
					loading: false,
					data: d,
					error: null,
				}, () => _.isFunction(onLoadSuccess) && onLoadSuccess(d));
			},
			onError: (xhr) => this.setState({
				loading: false,
				error: loadErrMsg,
			}, () => _.isFunction(onLoadError) && onLoadError()),
		}).send();
	}

	finder(_data, kw) {
		let { nonEmpName, nonEmpNo, idcNo } = _data;
		const exp = new RegExp(_.escapeRegExp(kw), 'i');
		return nonEmpNo && exp.test(nonEmpNo) || nonEmpName && exp.test(nonEmpName) || idcNo && exp.test(idcNo);
	}

	renderTag(_data, idx) {
		return <>
			<i className={`fa fa-${_data.nonEmpType === 0 ? 'user-secret' : 'building'} fa-xs color-blue`} /> {_data.nonEmpName}
		</>;
	}

	renderItem(data, idx) {
		return <>
			<small className={'color-lightGray'}>{idx + 1}. </small>
			<div className="fa-stack fa-xs">
				<i className="fas fa-square fa-stack-2x color-lightGray50" />
				<i className={`fa fa-${data.nonEmpType === 0 ? 'user-secret' : 'building'} fa-stack-1x fa-inverse color-blue`} />
			</div>
			<span className={'-name text-medium'}>
				{data.nonEmpName} <small className={'extra'}>{data.nonEmpNo}</small>
			</span>
			<small className={'-info text-ellipsis'}>
				<div>{data.idcNo}</div>
			</small>
		</>;
	}

	buildAdvCriteria(criteria, update) {
		const advMenuProps = {
			eventLevel: 1,
			height: [0, 200],
			isCount: false,
			stickOffset: { x: -40, y: 3 },
			stickDirection: 'bottom',
			pointer: 'top',
			pointerClassName: 'sm',
			pointerStyle: { left: 35 },
			width: 0,
			className: 'level2',
		};

		const _nonEmpNoEvent = v => {
			if (_.isNil(v) || !v[0] && !v[1]) delete criteria.nonEmpNo;
			else criteria.nonEmpNo = v;
			update();
		};
		const _nonEmpNameEvent = v => {
			if (_.isEmpty(v)) delete criteria.nonEmpName;
			else criteria.nonEmpName = v;
			update();
		};
		const _nationalityEvent = v => {
			if (_.isNil(v)) delete criteria.nationality;
			else criteria.nationality = _.isArray(v) ? v : [v];
			update();
		};
		const _idcNoEvent = v => {
			if (_.isNil(v) || !v[0] && !v[1]) delete criteria.idcNo;
			else criteria.idcNo = v;
			update();
		};
		const _nonEmpTypeEvent = v => {
			if (_.isNil(v)) delete criteria.nonEmpType;
			else criteria.nonEmpType = _.isArray(v) ? v : [v];
			update();
		};

		return <>
			<div className={'-item'}>
				<i className={'fal fa-id-card fa-xs'} />
				<TextRange {...{
					className: 'empty sm -gum',
					width: 170,
					inputTheme: 'empty sm -gum',
					placeholder: [
						OptionUtils.getLabel('components.EmpUtils', 'fromTheCodeNameOfThe'),
						OptionUtils.getLabel('components.EmpUtils', 'theRecipientCodeName')
					],
					onEditing: _nonEmpNoEvent,
					onUpdate: _nonEmpNoEvent,
				}} />
			</div>
			<div className={'-item'}>
				<i className={'fal fa-id-card fa-xs'} />
				<Text {...{
					className: 'empty sm -gum',
					width: 100,
					placeholder: OptionUtils.getLabel('components.EmpUtils', 'nameOfTheRecipient'),
					onEditing: _nonEmpNameEvent,
					onUpdate: _nonEmpNameEvent,
				}} />
			</div>
			<div className={'-item'}>
				<i className={'fal fa-id-card fa-xs'} />
				<OptionPicker {...{
					data: 'ed.base.country',
					className: 'empty sm',
					behavior: 'simple',
					menuProps: advMenuProps,
					placeholder: OptionUtils.getLabel('components.EmpUtils', 'nationality'),
					onEditing: _nationalityEvent,
					onUpdate: _nationalityEvent,
				}} />
			</div>
			<div className={'-item'}>
				<i className={'fal fa-id-card fa-xs'} />
				<TextRange {...{
					className: 'empty sm -gum',
					width: 260,
					inputTheme: 'empty sm -gum',
					placeholder: [
						OptionUtils.getLabel('components.EmpUtils', 'iDNumberCompanyCompilation'),
						OptionUtils.getLabel('components.EmpUtils', 'iDorCompanyCompilation')
					],
					onEditing: _idcNoEvent,
					onUpdate: _idcNoEvent,
				}} />
			</div>
			<div className={'-item'}>
				<i className={'fal fa-id-card fa-xs'} />
				<OptionPicker {...{
					data: 'pb.teaxyear.nonempType',
					className: 'empty sm',
					behavior: 'simple',
					menuProps: advMenuProps,
					placeholder: OptionUtils.getLabel('components.EmpUtils', 'categoryOfEarner'),
					onEditing: _nonEmpTypeEvent,
					onUpdate: _nonEmpTypeEvent,
				}} />
			</div>
		</>;
	}

	buildMenuProps() {
		const { menuProps, isAdvCriteria } = this.props;
		const { adv, moreHint } = this.state;

		return _.assign({}, menuProps, {
			renderCriteria: (criteria, update, selectAllBtn) => {
				const { kw } = criteria;

				const _kwEvent = v => {
					v = v.trim();
					if (v === kw) return;
					criteria.kw = v;
					update();
				};

				return <>
					<div className={'flex-row'}>
						<i className={'fal fa-fw fa-search fa-sm color-gray'} style={{ margin: '0 0 0 3px' }} />
						<Text {...{
							className: 'empty sm -gum',
							initValue: kw || '',
							placeholder: menuProps.placeholder,
							onEditing: _kwEvent,
						}} />
						{selectAllBtn}
						{isAdvCriteria && <>
							{!adv && moreHint && <small className={'color-blue zoom-p90'}>
								{OptionUtils.getLabel('components.EmpUtils', 'moreSearchCriteria')} <i className={'fal fa-arrow-right'} />
							</small>}
							<span {...{
								className: `btn btn-xs square btn-info fa fa-sliders-h-square ${adv ? ' active' : ''}`,
								style: { margin: '0 2px' },
								onClick: evt => {
									if (adv)
										_.each(_.keys(criteria), prop => {
											if (prop !== 'kw') delete criteria[prop];
										});
									this.setState({ adv: !adv }, update);
								},
								...adv ? null : {
									onMouseEnter: evt => this.setState({ moreHint: true }),
									onMouseLeave: evt => this.setState({ moreHint: false }),
								},
							}} />
						</>}
					</div>
					{adv && <div className={'flex-row'} style={{ borderTop: '1px dashed #DDD' }}>
						{this.buildAdvCriteria(criteria, update)}
					</div>}
				</>;
			},
			filterCriteria: (data, criteria, finder) => {
				let { kw, nonEmpNo = [], nonEmpName, nationality, idcNo = [], nonEmpType } = criteria;
				let regExp;
				if (nonEmpNo[0]) nonEmpNo[0] = nonEmpNo[0].toUpperCase();
				if (nonEmpNo[1]) nonEmpNo[1] = nonEmpNo[1].toUpperCase();
				if (nonEmpName) regExp = new RegExp(_.escapeRegExp(nonEmpName), 'i');
				if (idcNo[0]) idcNo[0] = idcNo[0].toUpperCase();
				if (idcNo[1]) idcNo[1] = idcNo[1].toUpperCase();
				return _.filter(data, d => {
					const _nonEmpNo = d.nonEmpNo && d.nonEmpNo.toUpperCase() || '';
					const _idcNo = d.idcNo && d.idcNo.toUpperCase() || '';
					return (kw ? finder(d, kw) : true) &&
						(nonEmpNo[0] ? nonEmpNo[0] <= _nonEmpNo : true) &&
						(nonEmpNo[1] ? nonEmpNo[1] >= _nonEmpNo || _nonEmpNo.startsWith(nonEmpNo[1]) : true) &&
						(regExp && d.nonEmpName ? regExp.test(d.nonEmpName) : true) &&
						(nationality ? _.includes(nationality, d.nationality) : true) &&
						(idcNo[0] ? idcNo[0] <= _idcNo : true) &&
						(idcNo[1] ? idcNo[1] >= _idcNo || _idcNo.startsWith(idcNo[1]) : true) &&
						(nonEmpType ? _.includes(nonEmpType, d.nonEmpType) : true);
				});
			},
		});
	}

	getNonEmps() {
		if (!this._picker || _.isEmpty(this._picker.state.data)) return undefined;
		return _.cloneDeep(_.filter(this._picker.state.data, '_selected'));
	}

	render() {
		const { loading, error, data } = this.state;
		if (loading) return <Loading />;
		if (error) return <span className={'color-red'}>
			<i className={'fa fa-exclamation-circle'} /> {error}
		</span>;

		const { validate, theme, initValue } = this.props;
		const isSingle = validate && validate.max === 1 && !theme;
		const _initValue = initValue || this._tempValue;
		if (_initValue) delete this._tempValue;

		return <Picker {...{
			..._.omit(this.props, 'type'),
			ref: ele => this._picker = ele,
			data,
			..._initValue ? { initValue: _initValue } : null,
			...isSingle ? { theme: 'select', allowUncheck: true } : null,
			finder: this.finder,
			renderTag: this.renderTag,
			renderItem: this.renderItem,
			menuProps: this.buildMenuProps(),
		}} />;
	}
}

class NonEmpCardPicker extends EmpCardPicker {
	constructor(props) {
		super(props);

		delete this.state.empId;

		const { value } = props;
		if (value) {
			this.state.value = value;
			this.state.stage = 'card';
		}
	}

	reset() {
		const { enable, editable } = this.state;
		if (!enable || !editable) return this;
		this.setState({ value: null, stage: 'input' });
		return this;
	}

	validate() {
		const { enable, editable, stage, value } = this.state;
		if (!enable || !editable) return true;

		return (stage == 'card' && value) || (stage === 'input' && this._input && this._input.validate());
	}

	getValue() {
		return this.state.value;
	}

	setValue(value) {
		this.setState({ value, stage: 'card' });
	}

	getNonEmp() {
		if (this.state.stage !== 'card') return null;
		return this._nonEmp;
	}

	render() {
		const { cardProps, onLoadSuccess, onRawDataLoadSuccess, api } = this.props;
		const { stage, value, editable, enable, hover } = this.state;

		return value && stage === 'card'
			? <div {...{
				ref: ele => this._dom.cardWrapper = ele,
				onClick: evt => enable && editable ? this.setState({ stage: 'input' }, () => {
					if (this._input) this._input.focus();
				}) : null,
				onMouseEnter: evt => this.setState({ hover: true }),
				onMouseLeave: evt => this.setState({ hover: false }),
			}}>
				<NonEmpCard {...{
					...cardProps,
					id: value,
					className: editable ? 'clickable' : 'readOnly',
					onLoadSuccess: (data) => {
						this._nonEmp = data || null;
						if (_.isFunction(onLoadSuccess)) onLoadSuccess();
					},
					onLoadError: () => this.setState({ stage: 'input', value: null }),
				}} />
				{hover ? <Tip {...{
					stick: this._dom.cardWrapper,
					stickDirection: 'auto',
					stickAlign: -1,
					close: () => this.setState({ hover: false }),
				}}>{OptionUtils.getLabel('components.EmpUtils', 'clickToPickOtherNonEmployees')}</Tip> : null}
			</div>
			: <NonEmpPicker {...{
				ref: ele => this._input = ele,
				...this.props,
				...this._data ? { data: this._data } : null,
				api,
				value,
				validate: {
					required: this.props.validate ? this.props.validate.required : true,
					max: 1,
				},
				allowUncheck: true,
				onUpdate: v => {
					const { onUpdate } = this.props;
					if (!v) return this.setState({ value: null }, () => _.isFunction(onUpdate) ? onUpdate() : null);
					this.setState({
						value: +v,
						stage: 'card',
					}, () => _.isFunction(onUpdate) ? onUpdate(v) : null);
				},
				onLoadSuccess: data => {
					this._data = data;
					_.isFunction(onRawDataLoadSuccess) ? onRawDataLoadSuccess(data) : null;
				},
				onBlur: () => this.state.value ? this.setState({ stage: 'card' }) : null,
			}} />;
	}
}

class NonEmpTwoSidePicker extends TwoSidePicker {
	static defaultProps = {
		...TwoSidePicker.defaultProps,
		theme: 'NonEmpTwoSidePicker',
		height: 300,
		shareProps: {
			unit: '人',
			renderItem: (data, idx) => {
				return <>
					<small className={'color-lightGray'}>{idx + 1}. </small>
					<div>
						<div className="fa-stack fa-xs">
							<i className="fas fa-square fa-stack-2x color-lightGray50" />
							<i className={`fa fa-${data.nonEmpType === 0 ? 'user-secret' : 'building'} fa-stack-1x fa-inverse color-blue`} />
						</div>
					</div>
					<div className="-info">
						<span className={'-name text-medium'}>
							{data.nonEmpName} <small className={'extra'}>{data.nonEmpNo}</small>
						</span>
						{' '}<small className={'-idcNo'}>{data.idcNo}</small>
					</div>
				</>;
			},
			basicCriteria: {
				kw: {
					label: '所得人代號/姓名/名稱',
					input: <Text {...{
						width: '100%',
						placeholder: '所得人代號/姓名/名稱',
					}} />,
				},
			},
			advCriteria: {
				nonEmpNoRng: {
					label: '所得人代號',
					input: <TextRange placeholder={['所得人代號起', '所得人代號訖']} />,
				},
				nonEmpName: {
					label: '所得人姓名/名稱',
					input: <Text placeholder="所得人姓名/名稱" />,
				},
				nationality: {
					label: '國籍',
					input: <OptionPicker {...{
						data: 'ed.base.country',
						placeholder: '國籍',
					}} />,
				},
				idcNoRng: {
					label: '身分證號/公司統編',
					input: <TextRange placeholder={['身分證號/公司統編起', '身分證號/公司統編訖']} />,
				},
				nonEmpType: {
					label: '所得人類別',
					input: <OptionPicker {...{
						data: 'pb.teaxyear.nonempType',
						placeholder: '所得人類別',
					}} />,
				},
			},
			filter: (criteria, _data) => {
				let { kw, nonEmpName } = criteria;

				if (!_.isNil(kw)) {
					const regexp = new RegExp(_.escapeRegExp(kw), 'gi');
					if (!(_data.nonEmpName && regexp.test(_data.nonEmpName) || _data.nonEmpNo && regexp.test(_data.nonEmpNo) || _data.idcNo && regexp.test(_data.idcNo)))
						return false;
				}
				if (!_.isNil(nonEmpName)) {
					const regexp = new RegExp(_.escapeRegExp(nonEmpName), 'gi');
					if (!_data.nonEmpName || !regexp.test(_data.nonEmpName)) return false;
				}

				// 值包含在陣列內
				if (_.some(['nationality', 'nonEmpType'], prop => {
					if (_.isNil(criteria[prop])) return false;
					const array = _.isArray(criteria[prop]) ? criteria[prop] : [criteria[prop]];
					return !_.includes(array, _data[prop]);
				})) {
					return false;
				}

				// 字串介於範圍內
				if (_.some(['nonEmpNo', 'idcNo'], prop => {
					const key = `${prop}Rng`;
					if (_.isNil(criteria[key])) return false;
					if (!_data[prop]) return true;
					const from = (criteria[key][0] || '').toUpperCase();
					const to = (criteria[key][1] || '').toUpperCase();
					const value = _data[prop].toUpperCase();
					return from && from > value || to && to < value && !value.startsWith(to);
				})) {
					return false;
				}

				return true;
			},
		},
		// leftProps: { title: '' },
		// rightProps: { title: '' },
	};
}

class AsyncNonEmpTwoSidePicker extends DataLoader {
	static propTypes = {
		...DataLoader.propTypes,
		component: PropTypes.elementType,
	};
	static defaultProps = {
		...DataLoader.defaultProps,
		api: '/api/non-employee/picker/all',
		isCache: false,
		component: NonEmpTwoSidePicker,
	};
}

const PresetBuilder = {};
const _buildStrLikeFn = (key, caseSensitive) => {
	return (criteria, data) => {
		if (_.isEmpty(criteria[key])) return true;
		return data[key] && RegExp(criteria[key].escapeRegExp(), caseSensitive ? '' : 'i').test(data[key]);
	};
};
const _buildIdIncludeFn = (key) => {
	return (criteria, data) => {
		if (criteria[key] === undefined) return true;
		if (_.isArray(criteria[key])) {
			if (criteria[key].includes(data[key]))
				return true;
		} else {
			if (criteria[key] === data[key])
				return true;
		}
		return false;
	};
};
const _buildTreeIdIncludeFn = (key, mainKey, subKey) => {
	return (criteria, data) => {
		if (criteria[key] === undefined) return true;
		const [mainIds, subIds] = v.TREE_LEAF(criteria[key]) || [];
		return _.includes(mainIds, data[mainKey]) || _.includes(subIds, data[subKey]);
	};
};
const _buildStrInRangeFn = (key) => {
	return (criteria, data) => {
		if (criteria[key] === undefined) return true;
		if (!data[key]) return false;
		const from = (criteria[key][0] || '').toUpperCase();
		const to = (criteria[key][1] || '').toUpperCase();
		const value = data[key].toUpperCase();
		return (!from || from <= value) && (!to || (value <= to || value.startsWith(to)));
	};
};
const _buildNumInRangeFn = PresetBuilder.buildNumInRangeFn = (key) => {
	return (criteria, data) => {
		if (criteria[key] === undefined) return true;
		if (_.isNil(data[key])) return false;
		const from = criteria[key][0];
		const to = criteria[key][1];
		const value = data[key];
		return (_.isNil(from) || from <= value) && (_.isNil(to) || value <= to);
	};
};
const basicCriteriaPreset = {
	//
};
const advCriteriaPreset = {
	no: {
		criteria: {
			label: OptionUtils.getLabel('global.normal', 'employeeNumber'),
			input: <TextRange {...{ placeholder: [
				OptionUtils.getLabel('components.EmpUtils', 'empNumberStart'),
				OptionUtils.getLabel('components.EmpUtils', 'empNumberEnd')
			] }} />,
		},
		filter: _buildStrInRangeFn('no'),
	},
	name: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'employeeName'),
			input: <Text />,
		},
		filter: _buildStrLikeFn('name', true),
	},
	ws: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'wordStatus'),
			input: <OptionPicker data="ed.job.workStatus" />,
		},
		filter: _buildIdIncludeFn('ws'),
	},
	dept: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'department'),
			input: <DepPicker {...{
				active: 1,
				orgType: 0,
				placeholder: OptionUtils.getLabel('components.EmpUtils', 'department'),
				minHeight: 0,
			}} />,
		},
		filter: (criteria, data) => {
			if (!criteria.dept) return true;
			const { depts, org } = criteria.dept;
			return _.includes(depts, data[`depId${org}`]);
		},
	},
	jobId: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'posts'),
			input: <EDJobPicker />,
		},
		filter: _buildIdIncludeFn('jobId'),
	},
	identityId: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'identityCategory'),
			input: <EDIdentityPicker />,
		},
		filter: _buildIdIncludeFn('identityId'),
	},
	empType: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'directIndirect'),
			input: <OptionPicker data="ed.job.empType" />,
		},
		filter: _buildIdIncludeFn('empType'),
	},
	position: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'gradeGrade'),
			input: <EDPositionPicker />,
		},
		filter: _buildTreeIdIncludeFn('position', 'gradeId', 'levelId'),
	},
	location: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'workAreaLocation'),
			input: <EDLocationPicker />,
		},
		filter: _buildTreeIdIncludeFn('location', 'areaId', 'siteId'),
	},
	shiftType: {
		criteria: { label: OptionUtils.getLabel('components.EmpUtils', 'classAttributes'), input: <OptionPicker data="am.base.shiftType" /> },
		filter: _buildIdIncludeFn('shiftType'),
	},
	otWorkhourId: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'workRules'),
			input: <AMOtWorkHourPicker />,
		},
		filter: _buildIdIncludeFn('otWorkhourId'),
	},
	totalHours: {
		criteria: {
			label: OptionUtils.getLabel('components.EmpUtils', 'scheduledHours'),
			input: <NumberRange placeholder={[
				OptionUtils.getLabel('components.EmpUtils', 'elapsedHoursOn'),
				OptionUtils.getLabel('components.EmpUtils', 'scheduledHoursToDate')
			]}/>,
		},
		filter: _buildNumInRangeFn('totalHours'),
	},
};
const _buildSideProps = (sideProps, applyDefault = false) => {
	if (!sideProps && !applyDefault) return undefined;
	const { basicCriteria, advCriteria } = sideProps;

	const _basicCriteria = {};
	const _advCriteria = {};
	const filters = [];
	if (basicCriteria) {
		for (let criterion of basicCriteria) {
			const preset = basicCriteriaPreset[criterion];
			if (preset) {
				_basicCriteria[criterion] = preset.criteria;
				filters.push(preset.filter);
			} else if (_.isPlainObject(criterion)) {
				const { key, criteria: _criteria, filter: _filter } = criterion;
				_basicCriteria[key] = _criteria;
				filters.push(_filter);
			}
		}
	}
	if (advCriteria) {
		for (let criterion of advCriteria) {
			const preset = advCriteriaPreset[criterion];
			if (preset) {
				_advCriteria[criterion] = preset.criteria;
				filters.push(preset.filter);
			} else if (_.isPlainObject(criterion)) {
				const { key, criteria: _criteria, filter: _filter } = criterion;
				_advCriteria[key] = _criteria;
				filters.push(_filter);
			}
		}
	}
	const filter = (criteria, data) => _.every(filters, filter => filter(criteria, data));

	return {
		...applyDefault && {
			renderItem: EmpTwoSidePicker._defRenderItem,
		},
		...sideProps,
		...basicCriteria && { basicCriteria: _basicCriteria },
		...advCriteria && { advCriteria: _advCriteria },
		...(basicCriteria || advCriteria) && { filter },
	};
};
const EmpTwoSidePicker = memo(forwardRef((props, ref) => {
	const { shareProps, leftProps, rightProps } = props;

	const _shareProps = useMemo(() => _buildSideProps(shareProps, true), [shareProps]);
	const _leftProps = useMemo(() => _buildSideProps(leftProps), [leftProps]);
	const _rightProps = useMemo(() => _buildSideProps(rightProps), [rightProps]);

	return <TwoSidePicker {...{
		...props,
		ref,
		shareProps: _shareProps,
		leftProps: _leftProps,
		rightProps: _rightProps,
	}} />;
}));
EmpTwoSidePicker.displayName = 'EmpTwoSidePicker';
EmpTwoSidePicker._defRenderItem = (_data, idx) => <div className="-label">
	<span>{_data.no} {_data.name}</span>
	<span className="-dep">{adapt(_data.depName)}</span>
</div>;
const defBasicCriteria = [{
	key: 'keyword',
	criteria: {
		label: getLabel('components.EmpUtils', 'keywords') ,
		input: <Text placeholder={getLabel('components.EmpUtils', 'keywords') } />,
	},
	filter: (criteria, data) => {
		if (criteria.keyword === undefined) return true;
		const regexp = RegExp(_.escapeRegExp(criteria.keyword), 'i');
		return regexp.test(data.name) || regexp.test(data.no);
	},
}];
const defAdvCriteria = [
	'no', 'name', 'ws', 'dept', 'jobId', 'identityId',
	'empType', 'position', 'location',
];
EmpTwoSidePicker.applyDefault = (props) => {
	return defaultsDeepButNotArray(props, {
		height: 380,
		theme: 'ReCalcSalary',
		shareProps: {
			basicCriteria: defBasicCriteria,
			advCriteria: defAdvCriteria,
		},
		leftProps: { title: getLabel('components.EmpUtils', 'unselect') },
		rightProps: { title: getLabel('components.EmpUtils', 'selected') },
	});
};

class AsyncEmpTwoSidePicker extends PickerWrapper {
	state = {
		...this.state,
		data: null,
	};

	componentDidMount() {
		super.componentDidMount();
		const { api, loadOpts } = this.props;
		if (api) {
			this._ajax = new H2.Ajax({
				url: api,
				...loadOpts,
				onRequest: () => {
					if (_.isFunction(loadOpts.onLoading)) loadOpts.onLoading();
				},
				onSuccess: data => {
					this.setState({ data }, () => {
						if (_.isFunction(loadOpts.onLoaded)) loadOpts.onLoaded();
					});
				},
				onError: () => {
					if (_.isFunction(loadOpts.onLoaded)) loadOpts.onLoaded();
				},
			}).send();
		}
	}

	render() {
		const { data } = this.state;
		return <EmpTwoSidePicker {...{
			...this.props,
			ref: ele => this._picker = ele,
			readOnly: data === null,
			data: data || [],
		}} />;
	}
}
AsyncEmpTwoSidePicker.applyDefault = EmpTwoSidePicker.applyDefault;

export {
	EmpAvatar, EmpCard, EmpPicker, EmpCardPicker, EmpRuleMaker, EmpCardQueryPicker, EmpQueryPicker, EmpCardQuery,
	NonEmpCard, NonEmpPicker, NonEmpCardPicker, AsyncNonEmpTwoSidePicker, NonEmpTwoSidePicker,
	EmpTwoSidePicker, AsyncEmpTwoSidePicker, PresetBuilder, ConditionItems,
};
